import React, { useEffect, useState } from "react";
import AdminNavBarMain from "./AdminNavBarMain";
import * as XLSX from "xlsx";
import "react-datepicker/dist/react-datepicker.css";
import FileSaver from "file-saver";
import Table from "react-bootstrap/Table";
import { useLocation, useNavigate } from "react-router-dom";
import axios from ".././axios-interceptor";
import { Form, Modal } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { saveAs } from "file-saver";
import Cookies from 'js-cookie';
import Select from 'react-select';
import {
  base_url,
  COMPLIANCE_PENDING,
  COMPLIANCE_APPROVED,
  COMPLIANCE_REJECTED,
  COMPLIANCE_NEW,
  BUSINESS_ROLE,
  INVESTOR_TYPE_COMPANY,
  INVESTOR_TYPE_INDIVIDUAL,
  AUDITOR_ROLE,
} from "./../utilities";
import Skeleton from "react-loading-skeleton";
import KycDetailsModal from "./KycDetailsModal";
import { TextAreaField } from "../BusinessFlow/Kycform";
import { CRYPTO_SECRET_KEY } from "../utilities";
import CryptoJS from 'crypto-js'
import { FaEye } from "react-icons/fa";
import { TiDeleteOutline } from "react-icons/ti";
import { decrypt } from "../utils";

const Compliance = (props) => {
  let ltwo = props.loading;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [modalLoanDetailsShow, setModalLoanDetailsShow] = useState(false);
  const [investorDetailsModal, setInvestorDetailsModal] = useState(false);
  const [indivInvestorDetailsModal, setIndivInvestorDetailsModal] = useState(false);
  const [investorApprovedModal, setInvestorApprovedModal] = useState(false);
  const [pendginLinkModal, setPendginLinkModal] = useState(false);
  const [approvedEyeDetailsModal, setApprovedEyeDetailsModal] = useState(false);
  const [kycDetailsModal, setKycDetailsModal] = useState(false);
  const [onBoardingEyeDetailsModal, setOnBoardingEyeDetailsModal] = useState(false);
  const [defaultvalue, setDefaultValue] = useState(false);
  const [allInvestorsCount, setAllInvestorCount] = useState();
  const [investorSubmissionCount, setInvestorSubmissionCount] = useState();

  const [invInterestData, setInvInterestData] = useState([]);
  const [invInterestFilter, setInvInterestFilter] = useState([]);
  const [onBoardFilter, setOnBoardFilter] = useState([]);
  const [investorSubmission, setInvestorSubmission] = useState([]);

  const [investorOnBoard, setInvestorOnBoard] = useState([]);
  const [investorOnBoardFilter, setInvestorOnBoardFilter] = useState([]);
  const [investorOnBoardCount, setInvestorOnBoardCount] = useState();

  const [firstValueInvOnBoard, setFirstValueInvOnBoard] = useState();
  const [secondValueInvOnBoard, setSecondValueInvOnBoard] = useState();
  const [thirdValueInvOnBoard, setThirdValueInvOnBoard] = useState();
  const [fourthValueInvOnBoard, setFourthValueInvOnBoard] = useState();
  const [fifthValueInvOnBoard, setFifthValueInvOnBoard] = useState();
  const [businessNameData, setBusinessNameData] = useState("");
  const [riskAssessmentCompleted, setRiskAssessmentCompleted] = useState(false);



  const [investorSubmissionFilter, setInvestorSubmissionFilter] = useState([]);
  let count = invInterestFilter.length;
  let Invcount = investorSubmissionFilter.length;
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  const [fourthValue, setFourthValue] = useState([]);
  const [fifthValue, setFifthValue] = useState([]);
  const [sixthValue, setSixthValue] = useState([]);


  const [onboardData, setOnboardData] = useState([]);

  const [firstOnboardBus, setFirstOnboardBus] = useState([]);
  const [secondOnboardBus, setSecondOnboardBus] = useState([]);
  const [thirdOnboardBus, setThirdOnboardBus] = useState([]);
  const [fourthOnboardBus, setFourthOnboardBus] = useState([]);
  const [fifthOnboardBus, setFifthOnboardBus] = useState([]);
  const [sixthOnboardBus, setSixthOnboardBus] = useState([]);


  const [firstValueInvSub, setFirstValueInvSub] = useState([]);
  const [secondValueInvSub, setSecondValueInvSub] = useState([]);
  const [thirdValueInvSub, setThirdValueInvSub] = useState([]);
  const [fourthValueInvBus, setFourthValueInvSub] = useState([]);
  const [fifthValueInvSub, setFifthValueInvSub] = useState([]);
  const [masterBusinessData, setMasterBusinessData] = useState([])
  const [getDocuments, setGetDocuments] = useState([])
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }


    if (Cookies.get("is_first_tab") == "false") {
      document.getElementById("onboarding-tab").classList.remove("active");
      document.getElementById("onboarding-tab-pane").classList.remove("active");
      if (Cookies.get('clicked_tab') === "newinvestment") {
        document.getElementById("newinvestment-tab").classList.add("active");
        document.getElementById("newinvestment-tab-pane").classList.add("active");
      } else if (Cookies.get('clicked_tab') === "business") {
        document.getElementById("business-tab").classList.add("active");
        document.getElementById("business-tab-pane").classList.add("active")
      }
      setDefaultValueForInvestor(true);
    } else {
      setDefaultValueForInvestor(false);
      document.getElementById("business-tab").classList.remove("active");
      document.getElementById("business-tab-pane").classList.remove("active");

      document.getElementById("newinvestment-tab").classList.remove("active");
      document.getElementById("newinvestment-tab-pane").classList.remove("active");

      document.getElementById("onboarding-tab").classList.add("active");
      document.getElementById("onboarding-tab-pane").classList.add("active");
    }


    if (Cookies.get("is_business_first_tab") == "false") {

      document.getElementById("onboardingbusiness-tab").classList.remove("active");
      document.getElementById("onboardingbusiness-tab-pane").classList.remove("active");

      document.getElementById("onboardinginvestor-tab").classList.add("active");
      document.getElementById("onboardinginvestor-tab-pane").classList.add("active")


    } else {

      document.getElementById("onboardingbusiness-tab").classList.add("active");
      document.getElementById("onboardingbusiness-tab-pane").classList.add("active");

      document.getElementById("onboardinginvestor-tab").classList.remove("active");
      document.getElementById("onboardinginvestor-tab-pane").classList.remove("active");
    }


    axios
      .post(base_url + "business-master/get_business_submissions")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data != undefined) {
          setLoading(false)
          setOnboardData(data)
          setOnBoardFilter(data)

          setFirstOnboardBus(data);
          setSecondOnboardBus(data);
          setThirdOnboardBus(data);
          setFourthOnboardBus(data);
          setFifthOnboardBus(data);
          setSixthOnboardBus(data);
        }
      })

    axios
      .post(base_url + "business-master/get_all_approved_businesses")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data != undefined) {
          setLoading(false);

          setInvInterestData(data);
          setAllInvestorCount(data.length);
          setInvInterestFilter(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
          setFourthValue(data);
          setFifthValue(data);
          setSixthValue(data);
          setDisplayedDataBus(data);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });


    axios
      .post(base_url + "investor-master/get_investor_submissions")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data !== undefined || data?.length > 0) {
          setLoading(false);
          // data.map((item) => {
          //   const today = new Date();
          //   const nextMonth = new Date(
          //     today.getFullYear(),
          //     today.getMonth() + 1,
          //     today.getDate()
          //   );
          //   let list_of_expired_docs = [];
          //   item.list_of_documents.forEach((ele, ind1) => {
          //     if (ele.expiry_date !== undefined || ele.expiry_date !== null) {
          //       if (
          //         ele.expiry_date > new Date().getTime() &&
          //         ele.expiry_date < nextMonth
          //       ) {
          //         ele.is_expired = true;
          //         list_of_expired_docs.push(ele);
          //       } else {
          //         ele.is_expired = false;
          //       }
          //     }
          //   });
          //   item.list_of_expired_docs = list_of_expired_docs;
          // });
          setInvestorOnBoard(data);

          setInvestorOnBoardFilter(data);
          setInvestorOnBoardCount(data.length);

          setFirstValueInvOnBoard(data);
          setSecondValueInvOnBoard(data);
          setThirdValueInvOnBoard(data);
          setFourthValueInvOnBoard(data);
          // setFifthValueInvOnBoard(data);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });



    axios
      .post(base_url + "investor-master/get_all_approved_investors")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data !== undefined || data?.length > 0) {
          setLoading(false);

          setInvestorSubmission(data);

          setInvestorSubmissionFilter(data);
          setInvestorSubmissionCount(data.length);
          setDisplayedDataInv(data);
          setFirstValueInvSub(data);
          setFourthValueInvSub(data);
          setSecondValueInvSub(data);
          setThirdValueInvSub(data);
          setFifthValueInvSub(data);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });


  }, []);




  const [show, setShow] = useState(false);
  // const handleCloseRejectClose = () => {
  //   setShow(false);
  // };
  const goToAdminDashboard = () => {
    navigate("/admindashboard");
  };
  function exportToExcelBusOnBoard() {
    let sample_data_array = [];
    let inv_data = onBoardFilter;
    inv_data.forEach((elem) => {
      let xl_object = {
        "Ref No": elem.business_reference_no,
        "Business Name": elem.business_name,
        "Contact Name": elem.contact_person,
        'Type': elem.business_type,
        "Current Turnover": elem.turnover,
        'Phone': elem.phone,
        'Country': elem.country,
        "Status": elem.onboard_status == COMPLIANCE_PENDING
          ? "Pending"
          : elem.onboard_status === COMPLIANCE_APPROVED
            ? "Approved"
            : "Rejected",
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = "business_submissions.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  function exportToExcel() {
    let sample_data_array = [];
    let inv_data = invInterestFilter;
    inv_data.forEach((elem) => {
      let xl_object = {
        "Ref No": elem.business_reference_no,
        "Business Name": elem.business_name,
        "Contact Name": elem.user_name,
        'Type': elem.business_type,
        "Current Turnover": elem.turnover,
        'Phone': elem.phone,
        'Country': elem.country,
        "Status": elem?.kyc_forms?.length === 0 ? "KYC need to upload" :
          elem.kyc_forms[0]?.status === COMPLIANCE_PENDING
            ? "Pending"
            : elem.kyc_forms[0]?.status === COMPLIANCE_APPROVED
              ? "Approved"
              : "Rejected",
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = "business_submissions.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  function exportToExcelInvOnBoard() {
    let sample_data_array = [];
    investorOnBoardFilter.forEach((elem) => {
      let xl_object = {
        "Ref No": elem.investor_reference_no,
        "Company Name": elem.investor_company_name,
        'Type': elem.type,
        "Contact Name": elem.investor_name,
        'Phone': elem.phone,
        'Country': elem.country,
        "Maximum Investment": elem.committed_principal ? "$" + " " + elem.committed_principal : "",
        'Status': elem.onboard_status == COMPLIANCE_PENDING
          ? "Pending"
          : elem.onboard_status === COMPLIANCE_APPROVED
            ? "Approved"
            : "Rejected",
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;
    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = "Investor_Onboarding.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }

  function exportToExcelInv() {
    let sample_data_array = [];
    investorSubmissionFilter.forEach((elem) => {
      let xl_object = {
        "Ref No": elem.investor_reference_no,
        "Company Name": elem.investor_company_name,
        'Type': elem.type,
        "Contact Name": elem.investor_name,
        'Phone': elem.phone,
        'Country': elem.country,
        "Maximum Investment": elem.committed_principal ? "$" + " " + elem.committed_principal : "",
        'Status':
          elem?.kyc_forms?.length === 0 ? "KYC need to upload" :
            elem.kyc_forms[0]?.status === COMPLIANCE_PENDING
              ? "Pending"
              : elem.kyc_forms[0]?.status === COMPLIANCE_APPROVED
                ? "Approved"
                : "Rejected",
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;
    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = "Investor_submissions.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }

  const [filterValues, setFilterValues] = useState({
    business: null,
    country: null,
    type: null,
    status: null,
    invCompany: null,
    invRefNo: null,
    invCountry: null,
    invContact: null,
    invStatus: null,
    businessSubName: null,
    businessSubCountry: null,
    businessSubContact: null,
    businessSubType: null,
    businessSubRefNo: null,
    invSubName: null,
    invSubRefNo: null,
    invSubCountry: null,
    invSubCont_name: null,
    maxInvestment: null

  });
  const clearFilters = () => {
    setInvInterestFilter(invInterestData);
    setDefaultValue(true);
    setFourthValue(invInterestData);
    setFirstValue(invInterestData);
    setSecondValue(invInterestData);
    setThirdValue(invInterestData);
    setFifthValue(invInterestData);
    setSixthValue(invInterestData);

    setOnBoardFilter(onboardData)
    setFourthOnboardBus(onboardData);
    setFirstOnboardBus(onboardData);
    setSecondOnboardBus(onboardData);
    setThirdOnboardBus(onboardData);
    setFifthOnboardBus(onboardData);
    setSixthOnboardBus(onboardData);

    setInvestorSubmissionFilter(investorSubmission);
    setFirstValueInvSub(investorSubmission);
    setSecondValueInvSub(investorSubmission);
    setThirdValueInvSub(investorSubmission);
    setFourthValueInvSub(investorSubmission);
    setFifthValueInvSub(investorSubmission);

    setInvestorOnBoardFilter(investorOnBoard);
    setFirstValueInvOnBoard(investorOnBoard);
    setSecondValueInvOnBoard(investorOnBoard);
    setThirdValueInvOnBoard(investorOnBoard);
    setFourthValueInvOnBoard(investorOnBoard);
    setFifthValueInvOnBoard(investorOnBoard);

    setInitialValue("")
    setSecondFilterValue("")
    setThirdFilterValue("")
    setFourthFilterValue("")
    setFifthFilterValue("")
    setInitialValuebus("")
    setSecondFilterValuebus("")
    setThirdFilterValuebus("")
    setFourthFilterValuebus("")
    setFifthFilterValuebus("")
    setSixthFilterValuebus("");
    setFilterValues({
      business: null,
      country: null,
      type: null,
      status: null,
      invCompany: null,
      invRefNo: null,
      invCountry: null,
      invContact: null,
      invStatus: null,
      businessSubName: null,
      businessSubCountry: null,
      businessSubContact: null,
      businessSubType: null,
      businessSubRefNo: null,
      invSubName: null,
      invSubRefNo: null,
      invSubCountry: null,
      invSubCont_name: null,
      maxInvestment: null
    });
  };

  const [initialOnBoardValue, setInitialOnBoardValue] = useState('')
  const [secondFilterOnBoardValue, setSecondFilterOnBoardValue] = useState('')
  const [thirdFilterOnBoardValue, setThirdFilterOnBoardValue] = useState('')
  const [fourthFilterOnBoardValue, setFourthFilterOnBoardValue] = useState('')


  const [initialValueOnBoard, setInitialValueOnBoard] = useState('')
  const [secondFilterValueOnBoard, setSecondFilterValueOnBoard] = useState('')
  const [thirdFilterValueOnBoard, setThirdFilterValueOnBoard] = useState('')
  const [fourthFilterValueOnBoard, setFourthFilterValueOnBoard] = useState('')
  const [fifthFilterValueOnBoard, setFifthFilterValueOnBoard] = useState('')



  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')
  const [fourthFilterValue, setFourthFilterValue] = useState('')
  const [fifthFilterValue, setFifthFilterValue] = useState('')

  const [initialValuebus, setInitialValuebus] = useState('')
  const [secondFilterValuebus, setSecondFilterValuebus] = useState('')
  const [thirdFilterValuebus, setThirdFilterValuebus] = useState('')
  const [fourthFilterValuebus, setFourthFilterValuebus] = useState('')
  const [fifthFilterValuebus, setFifthFilterValuebus] = useState('')
  const [sixthFilterValuebus, setSixthFilterValuebus] = useState('')
  const uniqueStatusType = ["Approved", "Pending", "Rejected"];
  const investmentRanges = [
    "1000 - 5000",
    "5001 - 10000",
    "10001 - 50000",
    "50001 - 100000",
    "100001 - 150000",
    "150001 - 200000",
    "200001 - 250000",
    "250001 - 300000",
    "300001 - 350000",
    "350001 - 400000",
    "400001 - 450000",
    "450001 - 500000",
    "500001 - 750000",
    "750001 - 1000000"
  ];
  const handleChangeInput = (e) => {
    const name = e.value;
    const value = e.label;
    if (name == "onboard_business") {
      setFilterValues(prev => ({
        ...prev,
        business: value
      }));
      if (name === "onboard_business" && secondFilterOnBoardValue === '' && thirdFilterOnBoardValue === '' && fourthFilterOnBoardValue === '') {
        setInitialOnBoardValue("onboard_business")
        let f = firstOnboardBus.filter((item) => {
          if (value === item.business_name) {
            return item;
          }

        });
        setOnBoardFilter(f);
        setSecondOnboardBus(f);
        setThirdOnboardBus(f);
        setFourthOnboardBus(f);
      }
      if (name === "onboard_business" && secondFilterOnBoardValue !== '') {
        let f = firstOnboardBus.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setFourthOnboardBus(f);
        setThirdOnboardBus(f);

      }
      if (name === "onboard_business" && thirdFilterOnBoardValue !== '') {
        let f = firstOnboardBus.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setSecondOnboardBus(f);
        setFourthOnboardBus(f);
      }

      if (name === "onboard_business" && fourthFilterOnBoardValue !== '') {
        let f = firstOnboardBus.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setSecondOnboardBus(f);
        setThirdOnboardBus(f);

      }

    }

    if (name === "onboard_country") {
      setFilterValues(prev => ({
        ...prev,
        country: value
      }));

      if (name === "onboard_country" && initialOnBoardValue === '' && thirdFilterOnBoardValue === '' && fourthFilterOnBoardValue === '') {

        setSecondFilterOnBoardValue("onboard_country")
        let f = secondOnboardBus.filter((item) => {
          if (value === item.country) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setFirstOnboardBus(f)
        setThirdOnboardBus(f);
        setFourthOnboardBus(f);
      }
      if (name === "onboard_country" && initialOnBoardValue !== '') {

        setSecondFilterOnBoardValue("onboard_country")
        let f = secondOnboardBus.filter((item) => {
          if (value === item.country) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setThirdOnboardBus(f);
        setFourthOnboardBus(f);
      }
      if (name === "onboard_country" && thirdFilterOnBoardValue !== '') {

        setSecondFilterOnBoardValue("onboard_country")
        let f = secondOnboardBus.filter((item) => {
          if (value === item.country) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setFirstOnboardBus(f);
        setFourthOnboardBus(f);
      }

      if (name === "onboard_country" && fourthFilterOnBoardValue !== '') {

        setSecondFilterOnBoardValue("onboard_country")
        let f = secondOnboardBus.filter((item) => {
          if (value === item.country) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setFirstOnboardBus(f);
        setThirdOnboardBus(f);
      }
    }

    if (name === "onboard_type") {
      setFilterValues(prev => ({
        ...prev,
        type: value
      }));
      if (name === "onboard_type" && secondFilterOnBoardValue === '' && initialOnBoardValue === '' && fourthFilterOnBoardValue === '') {
        setThirdFilterOnBoardValue("onboard_type")
        let f = thirdOnboardBus.filter((item) => {
          if (value === item.business_type) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setFirstOnboardBus(f);
        setSecondOnboardBus(f);
        setFourthOnboardBus(f);
      }
      if (name === "onboard_type" && secondFilterOnBoardValue === '') {
        setThirdFilterOnBoardValue("onboard_type")
        let f = thirdOnboardBus.filter((item) => {
          if (value === item.business_type) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setSecondOnboardBus(f);
        setFourthOnboardBus(f);
      }
      if (name === "onboard_type" && initialOnBoardValue !== '') {
        setThirdFilterOnBoardValue("onboard_type")
        let f = thirdOnboardBus.filter((item) => {
          if (value === item.business_type) {
            return item;
          }
        });
        setOnBoardFilter(f);
        setFirstOnboardBus(f);
        setFourthOnboardBus(f);
      }
      if (name === "onboard_type" && fourthFilterOnBoardValue !== '') {
        setThirdFilterOnBoardValue("onboard_type")
        let f = thirdOnboardBus.filter((item) => {
          if (value === item.business_type) {
            return item;
          }

        });
        setOnBoardFilter(f);
        setFirstOnboardBus(f);
        setSecondOnboardBus(f);
      }
    }
    if (name === "status") {
      setFilterValues(prev => ({
        ...prev,
        status: value
      }));

      if (name === "status" && secondFilterOnBoardValue === '' && thirdFilterOnBoardValue === '' && initialOnBoardValue === '') {

        setInitialOnBoardValue("onboard_status");
        const statusMapping = {
          1: "Pending",
          2: "Approved",
          3: "Rejected"
        };

        let f = firstOnboardBus.filter((item) => {
          const itemStatus = statusMapping[item.onboard_status] || "";
          if (value === itemStatus) {
            return item;
          }
        });

        setOnBoardFilter(f);
        setSecondOnboardBus(f);
        setThirdOnboardBus(f);
        setFirstOnboardBus(f);
      }


      if (name === "status" && initialOnBoardValue !== '') {
        setInitialOnBoardValue("onboard_status");
        const statusMapping = {
          1: "Pending",
          2: "Approved",
          3: "Rejected"
        };
        let f = fourthOnboardBus.filter((item) => {
          const itemStatus = statusMapping[item.onboard_status] || "";
          if (value === itemStatus) {
            return item;
          }
        });

        setOnBoardFilter(f);
        setSecondOnboardBus(f);
        setThirdOnboardBus(f);
        setFirstOnboardBus(f);
      }

      if (name === "status" && secondFilterOnBoardValue !== '') {
        setInitialOnBoardValue("onboard_status");
        const statusMapping = {
          1: "Pending",
          2: "Approved",
          3: "Rejected"
        };
        let f = fourthOnboardBus.filter((item) => {
          const itemStatus = statusMapping[item.onboard_status] || "";
          if (value === itemStatus) {
            return item;
          }
        });

        setOnBoardFilter(f);
        setThirdOnboardBus(f);
        setFirstOnboardBus(f);
      }

      if (name === "status" && thirdFilterOnBoardValue !== '') {
        setInitialOnBoardValue("onboard_status");
        const statusMapping = {
          1: "Pending",
          2: "Approved",
          3: "Rejected"
        };
        let f = fourthOnboardBus.filter((item) => {
          const itemStatus = statusMapping[item.onboard_status] || "";
          if (value === itemStatus) {
            return item;
          }
        });

        setOnBoardFilter(f);
        setSecondOnboardBus(f);
        setFirstOnboardBus(f);
      }

    }
    if (name === "inv_comp_name_onboard") {

      setFilterValues(prev => ({
        ...prev,
        invCompany: value
      }));
      if (name === "inv_comp_name_onboard" && secondFilterValueOnBoard === '' && thirdFilterValueOnBoard === '' && fourthFilterValueOnBoard === '' && fifthFilterValueOnBoard === '') {
        setInitialValue("inv_comp_name_onboard")
        let f = firstValueInvOnBoard.filter((item) => {
          if (value === item.investor_company_name) {
            return item;
          }
        });
        setInvestorOnBoardFilter(f);
        setSecondValueInvOnBoard(f);
        setThirdValueInvOnBoard(f);
        setFourthValueInvOnBoard(f);
        setFifthValueInvOnBoard(f);
      }
      if (name === "inv_comp_name_onboard" && fourthFilterValueOnBoard !== '') {
        let f = firstValueInvOnBoard.filter((item) => {
          if (value === item.investor_company_name) {
            return item;
          }
        });
        setInvestorOnBoardFilter(f);
        setSecondValueInvOnBoard(f);
        setThirdValueInvOnBoard(f);
        setFifthValueInvOnBoard(f);
      }
    }
    if (name === "inv_refNo_onboard") {
      setFilterValues(prev => ({
        ...prev,
        invRefNo: value
      }));
      if (name === "inv_refNo_onboard" && initialValueOnBoard === '' && thirdFilterValueOnBoard === '' && fourthFilterValueOnBoard === '' && fifthFilterValueOnBoard === '') {
        setSecondFilterValue("inv_refNo_onboard")
        let f = secondValueInvOnBoard.filter((item) => {
          if (value === item.investor_reference_no) {
            return item;
          }
        });
        setInvestorOnBoardFilter(f);
        setFirstValueInvOnBoard(f);
        setThirdValueInvOnBoard(f);
        setFourthValueInvOnBoard(f);
        setFifthValueInvOnBoard(f);
      }
      if (name === "inv_refNo_onboard" && initialValueOnBoard !== '') {
        let f = secondValueInvOnBoard.filter((item) => {
          if (value === item.investor_reference_no) {
            return item;
          }
        });
        setInvestorOnBoardFilter(f);
        setThirdValueInvOnBoard(f);
        setFourthValueInvOnBoard(f);
        setFifthValueInvOnBoard(f);
      }
      if (name === "inv_refNo_onboard" && fourthFilterValueOnBoard !== '') {
        let f = secondValueInvOnBoard.filter((item) => {
          if (value === item.investor_reference_no) {
            return item;
          }
        });
        setInvestorOnBoardFilter(f);
        setThirdValueInvOnBoard(f);
        setFifthValueInvOnBoard(f);
        setFirstValueInvOnBoard(f);
      }
    }
    if (name === "inv_country_onboard") {
      setFilterValues(prev => ({
        ...prev,
        invCountry: value
      }));

      if (name === "inv_country_onboard" && initialValueOnBoard === '' && secondFilterValueOnBoard === '' && fourthFilterValueOnBoard === '' && fifthFilterValueOnBoard === '') {
        let f = thirdValueInvOnBoard.filter((item) => {
          if (value === item.country) {
            return item;
          }
        });
        setInvestorOnBoardFilter(f);
        setFirstValueInvOnBoard(f);
        setSecondValueInvOnBoard(f);
        setFourthValueInvOnBoard(f);
        setFifthValueInvOnBoard(f);
      }
    }
    if (name === "inv_contct_onboard") {
      setFilterValues(prev => ({
        ...prev,
        invContact: value
      }));
      if (name === "inv_contct_onboard" && initialValueOnBoard === '' && secondFilterValueOnBoard === '' && thirdFilterValueOnBoard === '' && fifthFilterValueOnBoard === '') {
        setFourthFilterValue("inv_contct_onboard")
        let f = fourthValueInvOnBoard.filter((item) => {
          if (value === item.investor_name) {
            return item;
          }
        });
        setInvestorOnBoardFilter(f);
        setFirstValueInvOnBoard(f);
        setSecondValueInvOnBoard(f);
        setThirdValueInvOnBoard(f);
        setFifthValueInvOnBoard(f);
      }
    }

    if (name === "invStatus") {
      setFilterValues(prev => ({
        ...prev,
        invStatus: value
      }));

      if (name === "invStatus" &&
        initialValueOnBoard === '' && secondFilterValueOnBoard === '' && thirdFilterValueOnBoard === '' && fourthFilterValueOnBoard === ''

      ) {

        setInitialValue("onboard_status");
        const statusMapping = {
          1: "Pending",
          2: "Approved",
          3: "Rejected"
        };

        let f = firstValueInvOnBoard.filter((item) => {
          const itemStatus = statusMapping[item.onboard_status] || "";
          if (value === itemStatus) {
            return item;
          }
        });

        setInvestorOnBoardFilter(f);
        setSecondValueInvOnBoard(f);
        setThirdValueInvOnBoard(f);
        setFourthValueInvOnBoard(f);
      }
    }
    if (name === "inv_maxinv_onboard") {
      setFilterValues(prev => ({
        ...prev,
        maxInvestment: value
      }));
      setFifthFilterValue("inv_maxinv");
      const [minStr, maxStr] = value.split(" - ");
      const minValue = parseInt(minStr.replace(/,/g, ''));
      const maxValue = parseInt(maxStr.replace(/,/g, ''));
      let currentData;
      if (initialValue !== '') {
        currentData = firstValueInvSub;
      } else if (secondFilterValue !== '') {
        currentData = secondValueInvSub;
      } else if (thirdFilterValue !== '') {
        currentData = thirdValueInvSub;
      } else if (fourthFilterValue !== '') {
        currentData = fourthValueInvBus;
      } else {
        currentData = investorSubmission;
      }

      let filtered = currentData.filter(item => {
        const committedAmount = parseInt(item.committed_principal || '0');
        return committedAmount >= minValue && committedAmount <= maxValue;
      });

      setInvestorSubmissionFilter(filtered);
      setFirstValueInvSub(filtered);
      setSecondValueInvSub(filtered);
      setThirdValueInvSub(filtered);
      setFourthValueInvSub(filtered);
      setFifthValueInvSub(filtered);
    }

































    if (name === "inv_comp_name") {
      setFilterValues(prev => ({
        ...prev,
        invSubName: value
      }));

      if (name === "inv_comp_name" && secondFilterValue === '' && thirdFilterValue === '' && fourthFilterValue === '' && fifthFilterValue === '') {
        setInitialValue("inv_comp_name")
        let f = firstValueInvSub.filter((item) => {
          if (value === item.investor_company_name) {
            return item;
          }
        });
        setInvestorSubmissionFilter(f);
        setSecondValueInvSub(f);
        setThirdValueInvSub(f);
        setFourthValueInvSub(f);
        setFifthValueInvSub(f);
      }
      if (name === "inv_comp_name" && fourthFilterValue !== '') {
        let f = firstValueInvSub.filter((item) => {
          if (value === item.investor_company_name) {
            return item;
          }
        });
        setInvestorSubmissionFilter(f);
        setSecondValueInvSub(f);
        setThirdValueInvSub(f);
        setFifthValueInvSub(f);
      }
    }
    if (name === "inv_refNo") {
      setFilterValues(prev => ({
        ...prev,
        invSubRefNo: value
      }));

      if (name === "inv_refNo" && initialValue === '' && thirdFilterValue === '' && fourthFilterValue === '' && fifthFilterValue === '') {
        setSecondFilterValue("inv_refNo")
        let f = secondValueInvSub.filter((item) => {
          if (value === item.investor_reference_no) {
            return item;
          }
        });
        setInvestorSubmissionFilter(f);
        setFirstValueInvSub(f);
        setThirdValueInvSub(f);
        setFourthValueInvSub(f);
        setFifthValueInvSub(f);
      }
      if (name === "inv_refNo" && initialValue !== '') {
        let f = secondValueInvSub.filter((item) => {
          if (value === item.investor_reference_no) {
            return item;
          }
        });
        setInvestorSubmissionFilter(f);
        setThirdValueInvSub(f);
        setFourthValueInvSub(f);
        setFifthValueInvSub(f);
      }
      if (name === "inv_refNo" && fourthFilterValue !== '') {
        let f = secondValueInvSub.filter((item) => {
          if (value === item.investor_reference_no) {
            return item;
          }
        });
        setInvestorSubmissionFilter(f);
        setThirdValueInvSub(f);
        setFifthValueInvSub(f);
        setFirstValueInvSub(f);
      }
    }

    if (name === "inv_country") {
      setFilterValues(prev => ({
        ...prev,
        invSubCountry: value
      }));

      if (name === "inv_country" && initialValue === '' && secondFilterValue === '' && fourthFilterValue === '' && fifthFilterValue === '') {
        let f = thirdValueInvSub.filter((item) => {
          if (value === item.country) {
            return item;
          }
        });
        setInvestorSubmissionFilter(f);
        setFirstValueInvSub(f);
        setSecondValueInvSub(f);
        setFourthValueInvSub(f);
        setFifthValueInvSub(f);
      }
    }
    if (name === "inv_contct") {
      setFilterValues(prev => ({
        ...prev,
        invSubCont_name: value
      }));

      if (name === "inv_contct" && initialValue === '' && secondFilterValue === '' && thirdFilterValue === '' && fifthFilterValue === '') {
        setFourthFilterValue("inv_contct")
        let f = fourthValueInvBus.filter((item) => {
          if (value === item.investor_name) {
            return item;
          }
        });
        setInvestorSubmissionFilter(f);
        setFirstValueInvSub(f);
        setSecondValueInvSub(f);
        setThirdValueInvSub(f);
        setFifthValueInvSub(f);
      }
    }
    if (name === "inv_maxinv" && initialValue === '' && secondFilterValue === '' && thirdFilterValue === '' && fourthFilterValue === '') {
      let startRange = value.split("-")[0];
      let endRange = value.split("-")[1];

      let f = fifthValueInvSub.filter((item) => {
        if (
          item.committed_principal >= startRange &&
          item.committed_principal <= endRange
        ) {
          return item;
        }
      });
      setInvestorSubmissionFilter(f);
      setFirstValueInvSub(f);
      setSecondValueInvSub(f);
      setThirdValueInvSub(f);
      setFourthValueInvSub(f);
    }

    if (name === "business") {
      setFilterValues(prev => ({
        ...prev,
        businessSubName: value
      }));


      if (name === "business" && secondFilterValuebus === '' && thirdFilterValuebus === '' && fourthFilterValuebus === '' && fifthFilterValuebus === '' && sixthFilterValuebus === '') {
        setInitialValuebus("business")
        let f = firstValue.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setSecondValue(f);
        setThirdValue(f);
        setFourthValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "business" && fifthFilterValuebus !== '' && thirdFilterValuebus !== '') {
        let f = firstValue.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setSecondValue(f);
        setFourthValue(f);
        setSixthValue(f);
      }
      if (name === "business" && thirdFilterValuebus !== '') {
        let f = firstValue.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setSecondValue(f);
        setFourthValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "business" && fifthFilterValuebus !== '') {
        let f = firstValue.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setSecondValue(f);
        setFourthValue(f);
        setThirdValue(f);
        setSixthValue(f);
      }
      if (name === "business" && fourthFilterValuebus !== '') {
        let f = firstValue.filter((item) => {
          if (value === item.business_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setSecondValue(f);
        setFifthValue(f);
        setThirdValue(f);
        setSixthValue(f);
      }
    }
    if (name === "refNo") {
      setFilterValues(prev => ({
        ...prev,
        businessSubRefNo: value
      }));


      if (name === "refNo" && initialValuebus === '' && thirdFilterValuebus === '' && fourthFilterValuebus === '' && fifthFilterValuebus === '' && sixthFilterValuebus === '') {
        setSecondFilterValuebus("refNo")
        let f = secondValue.filter((item) => {
          if (value === item.business_reference_no) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setThirdValue(f);
        setFourthValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "refNo" && thirdFilterValuebus !== '' && fourthFilterValuebus !== '') {
        let f = secondValue.filter((item) => {
          if (value === item.business_reference_no) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "refNo" && thirdFilterValuebus !== '' && fifthFilterValuebus !== '') {
        let f = secondValue.filter((item) => {
          if (value === item.business_reference_no) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setFourthValue(f);
        setSixthValue(f);
      }
      if (name === "refNo" && thirdFilterValuebus !== '') {
        let f = secondValue.filter((item) => {
          if (value === item.business_reference_no) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setFourthValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "refNo" && fourthFilterValuebus !== '') {
        let f = secondValue.filter((item) => {
          if (value === item.business_reference_no) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setThirdValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "refNo" && fifthFilterValuebus !== '') {
        let f = secondValue.filter((item) => {
          if (value === item.business_reference_no) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setThirdValue(f);
        setFourthValue(f);
        setSixthValue(f);
      }
    }
    if (name === "country") {
      setFilterValues(prev => ({
        ...prev,
        businessSubCountry: value
      }));


      if (name === "country" && secondFilterValuebus === '' && initialValuebus === '' && fourthFilterValuebus === '' && fifthFilterValuebus === '' && sixthFilterValuebus === '') {
        setThirdFilterValuebus("country")
        let f = thirdValue.filter((item) => {
          if (value === item.country) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setSecondValue(f);
        setFourthValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
    }
    if (name === "cont_name") {
      setFilterValues(prev => ({
        ...prev,
        businessSubContact: value
      }));


      if (name === "cont_name" && secondFilterValuebus === '' && thirdFilterValuebus === '' && initialValuebus === '' && fifthFilterValuebus === '' && sixthFilterValuebus === '') {
        setFourthFilterValuebus("cont_name")
        let f = fourthValue.filter((item) => {
          if (value === item.user_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setSecondValue(f);
        setThirdValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "cont_name" && thirdFilterValuebus !== '') {
        let f = fourthValue.filter((item) => {
          if (value === item.user_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setSecondValue(f);
        setFifthValue(f);
        setSixthValue(f);
      }
      if (name === "cont_name" && fifthFilterValuebus !== '') {
        let f = fourthValue.filter((item) => {
          if (value === item.user_name) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setSecondValue(f);
        setThirdValue(f)
        setSixthValue(f);
      }
    }
    if (name === "type") {
      setFilterValues(prev => ({
        ...prev,
        businessSubType: value
      }));


      if (name === "type" && secondFilterValuebus === '' && thirdFilterValuebus === '' && fourthFilterValuebus === '' && initialValuebus === '' && sixthFilterValuebus === '') {
        setFifthFilterValuebus("type")
        let f = fifthValue.filter((item) => {
          if (value === item.business_type) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setSecondValue(f);
        setThirdValue(f);
        setFourthValue(f);
        setSixthValue(f);
      }
      if (name === "type" && thirdFilterValuebus !== '') {
        setFifthFilterValuebus("type")
        let f = fifthValue.filter((item) => {
          if (value === item.business_type) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setSecondValue(f);
        setFourthValue(f);
        setSixthValue(f);
      }
      if (name === "type" && fourthFilterValuebus !== '') {
        let f = fifthValue.filter((item) => {
          if (value === item.business_type) {
            return item;
          }
        });
        setInvInterestFilter(f);
        setFirstValue(f);
        setSecondValue(f);
        setThirdValue(f)
        setSixthValue(f);
      }
    }
    if (name === "turn_over" && secondFilterValuebus === '' && thirdFilterValuebus === '' && fourthFilterValuebus === '' && fifthFilterValuebus === '' && initialValuebus === '') {
      setSixthFilterValuebus("turn_over")
      let f = sixthValue.filter((item) => {

        if (value === item.turnover) {
          return item;
        }
      });
      setInvInterestFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }

    setDefaultValue(false);
  };

  const uniqueBusinessName = [
    ...new Set(firstValue.map((d) => d.business_name)),
  ];
  const uniqueOnBoardBusinessName = [
    ...new Set(firstOnboardBus.map((d) => d.business_name)),
  ];

  const uniqueContactName = [...new Set(fourthValue.map((d) => d.user_name))];

  const uniqueType = [...new Set(fifthValue.map((d) => d.business_type))];


  const uniqueOnboardBusType = [...new Set(thirdOnboardBus.map((d) => d.business_type))];

  const uniqueTurnOver = [...new Set(sixthValue.map((d) => d.turnover))];


  const uniquelrefNo = [
    ...new Set(secondValue?.map((d) => d.business_reference_no)),
  ];

  const uniquelCountry = [...new Set(thirdValue.map((d) => d.country))];

  const uniquelonBoardCountry = [...new Set(secondOnboardBus.map((d) => d.country))];

  const uniqueInvestorCompanyName = [
    ...new Set(firstValueInvSub?.map((d) => d.investor_company_name)),
  ];
  const uniqueInvestorCompanyNameOnBoard = [
    ...new Set(firstValueInvOnBoard?.map((d) => d.investor_company_name)),
  ];
  const uniqueInvRefNo = [
    ...new Set(secondValueInvSub?.map((d) => d.investor_reference_no)),
  ];
  const uniqueInvRefNoOnBoard = [
    ...new Set(secondValueInvOnBoard?.map((d) => d.investor_reference_no)),
  ];
  const uniqueInvCountry = [...new Set(thirdValueInvSub.map((d) => d.country))];
  const uniqueInvCountryOnBoard = [...new Set(thirdValueInvOnBoard?.map((d) => d.country))];
  const uniqueInvContct = [
    ...new Set(fourthValueInvBus?.map((d) => d.investor_name)),
  ];
  const uniqueInvContctOnBoard = [
    ...new Set(fourthValueInvOnBoard?.map((d) => d.investor_name)),
  ];


  const [defaultvalueInvestor, setDefaultValueForInvestor] = useState(false);
  const [defaultvalueOnboard, setDefaultValueForOnboard] = useState(false);
  const [clickedTabMain, setClickedTabMain] = useState('');

  const onBoardClick = (board) => {
    setClickedTabMain(board)
    Cookies.set("clicked_tab", board, { expires: 7 });
    Cookies.set("is_first_tab", true, { expires: 7 });
    setDefaultValueForInvestor(false);
  };
  const businessClick = (business) => {
    setClickedTabMain(business)
    Cookies.set("clicked_tab", business, { expires: 7 });
    Cookies.set("is_first_tab", false, { expires: 7 });
    setDefaultValueForInvestor(true);
  };


  const newInvestorIntrestsClick = (newinvestment) => {
    setClickedTabMain(newinvestment)
    Cookies.set("clicked_tab", newinvestment, { expires: 7 });
    Cookies.set("is_first_tab", false, { expires: 7 });
    setDefaultValueForInvestor(true);
  };


  const onBoardBusinessClick = () => {
    Cookies.set("is_business_first_tab", true, { expires: 7 });
    setDefaultValueForOnboard(false);
  };

  const onBoardingInvestorClick = () => {
    Cookies.set("is_business_first_tab", false, { expires: 7 });
    setDefaultValueForOnboard(true);
  };


  const columnsOnboardingBsns = [

    {
      title: "Business Name",
      field: "business_name",
    },

    {
      title: "Type",
      field: "business_type",
    },
    {
      title: "Phone",
      field: "phone",
    },

    {
      title: "Country",
      field: "country",
    },
    {
      title: "Referral",
      field: "referral",
    },
    {
      title: "Created on",
      field: "created_date_time",
    },

    {
      title: "Status",
      field: "status",
    },
    {
      title: "Actions",
      field: "image",
      image: "./images/eye.svg",
      datatopass: "",
    },
  ];
  const columns = [
    {
      title: "Ref No.",
      field: "business_reference_no",
    },
    {
      title: "Business Name",
      field: "business_name",
    },
    {
      title: "Contact Name",
      field: "user_name",
    },

    {
      title: "Type",
      field: "business_type",
    },
    {
      title: "Phone",
      field: "phone",
    },

    {
      title: "Country of Business",
      field: "country",
    },

    {
      title: "KYC Status",
      field: "status",
    },
    {
      title: "Actions",
      field: "image",
      image: "./images/eye.svg",
      datatopass: "",
    },
  ];
  const columnstwo = [
    { title: "Ref No", field: "investor_reference_no" },
    { title: "Company Name", field: "investor_company_name" },
    { title: "Type", field: "loan_reference_no" },
    {
      title: "Contact Name",
      field: "loan_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Phone", field: "bennefin_roi" },
    { title: "Country", field: "investor_roi" },
    { title: "Maximum Investment", field: "committed_principal" },
    { title: "KYC Status", field: "status" },

    {
      title: "Actions",
      field: "",
      image: "./images/eye.svg",
      datatopass: "",
    },
  ];
  const columnsOnBoardInv = [
    { title: "Ref No", field: "investor_reference_no" },
    { title: "Company Name", field: "investor_company_name" },
    { title: "Type", field: "loan_reference_no" },
    {
      title: "Contact Name",
      field: "loan_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Phone", field: "bennefin_roi" },
    { title: "Country", field: "investor_roi" },
    { title: "Created on", field: "created_date_time" },
    { title: "Status", field: "status" },

    {
      title: "Actions",
      field: "",
      image: "./images/eye.svg",
      datatopass: "",
    },
  ];

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...invInterestData].sort((a, b) => {
      const columnA = column == "loan_amount" ? parseInt(a[column]) : a[column];
      const columnB = column == "loan_amount" ? parseInt(b[column]) : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setInvInterestFilter(sortedData);
  };
  const handleSorttwo = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...investorSubmission].sort((a, b) => {
      const columnA = column == "loan_amount" ? parseInt(a[column]) : a[column];
      const columnB = column == "loan_amount" ? parseInt(b[column]) : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setInvestorSubmissionFilter(sortedData);
  };

  const [businessDetailsMomReport, setBusinessDetailsMomReport] = useState([]);

  const [quarterlyMomReports, setQuarterlyMomReports] = useState([]);





  const handleDataTopass = (business) => {
    setBusinessDetailsMomReport(business);
    axios
      .post(base_url + "mom-report-information/get_quarterly_call_reports", {
        business_id: business.business_id,
      })
      .then((res) => {
        let data = res.data.data[0];
        if (data !== "" || data !== undefined) {
          setQuarterlyMomReports(res.data?.data[0]);
        } else {
          console.log("No data found");
        }
      });
    setModalLoanDetailsShow(true);
  };

  const [pendingLinkData, setPendingLinkData] = useState([]);
  const [approvedLinkData, setApprovedLinkData] = useState([]);
  const [kycLinkData, setKycLinkData] = useState([]);
  const [onBoardingLinkData, setOnBoardingLinkData] = useState([]);


  const pendingLinkDetails = (data) => {
    setPendingLinkData(data);

    axios
      .post(
        base_url + "business-master/get_business_kyc_user",
        { user_id: data.user_id }
      )
      .then((res) => {
        setMasterBusinessData(res.data.data[0])
        setGetDocuments(res.data.data[1])

      })
  };
  const kycLink = (data) => {
    setKycLinkData(data);
  };
  const approvedLinkDetails = (data) => {
    setApprovedLinkData(data);
  };
  const onBoardingApprovalLink = (data) => {
    setOnBoardingLinkData(data);
  };
  const [displayedDataBus, setDisplayedDataBus] = useState([]);
  const [displayedDataInv, setDisplayedDataInv] = useState([]);
  const [invModalData, setInvModalData] = useState([]);
  const [invApprovedModalData, setInvApprovedModalData] = useState([]);
  const handleDatatoinvDetailModal = (data) => {
    setInvModalData(data);
  };
  const handleApprovedDetailModal = (data) => {
    setInvApprovedModalData(data);
  };
  const [role_code, setRoleCode] = useState(() => {
    const storedRoleCode = Cookies.get('role_code');
    return storedRoleCode ? storedRoleCode : '';
  });
  const handleChangeAllInputBus = (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      axios
        .post(base_url + 'business-master/get_all_approved_businesses', { filter_value: value })
        .then((res) => {
          let data = res.data.data;
          if (data && data.length > 0) {
            setInvInterestFilter(data);
          }
        })
        .catch((err) => {
          console.log(err, "error");
        })
    }
    if (value.length === 0) {
      setInvInterestFilter(displayedDataBus);
    }
  }

  const handleChangeAllInputInv = (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      axios
        .post(base_url + 'investor-master/get_all_approved_investors', { filter_value: value })
        .then((res) => {
          let data = res.data.data;
          if (data && data.length > 0) {
            setInvestorSubmissionFilter(data);
          }
        })
        .catch((err) => {
          console.log(err, "error");
        })
    }
    if (value.length === 0) {
      setInvestorSubmissionFilter(displayedDataInv);
    }
  }


  useEffect(() => {
    if (role_code) {
      try {
        const decryptedValueDataa = decrypt(role_code)
        setRoleCode(decryptedValueDataa);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  }, [])

  const location = useLocation();

 


  useEffect(() => {

    if (location.state?.reopenModal) {
      setPendginLinkModal(true);



      setPendingLinkData(location.state.pendingLinkData);
      setMasterBusinessData(location.state.singleBsnsData);
      setGetDocuments(location.state.getDocuments);
      setBusinessNameData(location.state.bname);
      setRiskAssessmentCompleted(location.state.riskAssessmentCompleted);

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);


  // useEffect(() => {

  //   if (location.state?.reopenModal) {

  //     setPendginLinkModal(true);
  //     setPendingLinkData(location.state.pendingLinkData);
  //     setMasterBusinessData(location.state.singleBsnsData);
  //     setGetDocuments(location.state.getDocuments);
  //     setBusinessNameData(location.state.bname);

  //     axios
  //       .post(base_url + "investor-master/get_all_approved_investors")
  //       .then((res) => {

  //         const responseData = res?.data?.data || [];

  //         // find investor
  //         const investorData = responseData.find(
  //           (item) =>
  //             item?.investor_id ===
  //             location.state?.pendingLinkData?.investor_id
  //         );

  //         if (investorData) {

  //           // find matching kyc form
  //           const matchedKyc = investorData?.kyc_forms?.find(
  //             (form) =>
  //               form?.investor_kyc_id ===
  //               location.state?.pendingLinkData?.investor_kyc_id
  //           );

  //           // store boolean separately
  //           setRiskAssessmentCompleted(
  //             matchedKyc?.risk_assessment_completed || false
  //           );

  //           // optional

  //         }


  //       })
  //       .catch((err) => {
  //         console.error(err);
  //       });

  //     navigate(location.pathname, {
  //       replace: true,
  //       state: {}
  //     });
  //   }

  // }, [location.state]);




  useEffect(() => {
    if (location.state?.reopenModal) {
      setPendginLinkModal(true);

      // clear state so refresh won't reopen
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  return (
    <div>
      <AdminNavBarMain />

      <div className="row admin_body_main position-static bg-transparent ">
        <div className="d-flex justify-content-between">
          <div className="col d-flex justify-content-between my-xxl-2  my-lg-1">
            <h5 className="admin_serv" onClick={() => goToAdminDashboard(true)}>
              <img
                src="./images/left_arrow.svg"
                alt=""
                className="indiv_loan_dtls"
              />
              &nbsp; Compliance
            </h5>
          </div>
          <div className="d-flex align-items-end">
            {clickedTabMain == "business" ? (
              <div className="container p-0">
                <div className="row d-flex justify-content-between mb-2">
                  <div className="col text-end">
                    <div className=" count_of_records_ALLSR mb-0">
                      <span>No.of Records : {count}</span>
                    </div>
                  </div>
                </div>
              </div>
            ) : clickedTabMain == "newinvestment" ? (
              <div className="container p-0">
                <div className="row d-flex justify-content-between mb-2">
                  <div className="col text-end">
                    <div className=" count_of_records_ALLSR mb-0">
                      <span>No.of Records : {Invcount}</span>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="">
        <div className="compliance_top_tab pe-5 ps-5">
          <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
            <li className="nav-item-inv" role="presentation">
              <button
                onClick={(e) => onBoardClick("onboard")}
                className="nav-link-inv  p-1"
                id="onboarding-tab"
                data-bs-toggle="tab"
                data-bs-target="#onboarding-tab-pane"
                type="button"
                role="tab"
                aria-controls="onboarding-tab-pane"
                aria-selected="true"
              >
                <h3>Onboarding  </h3>
              </button>
            </li>
            <li className="nav-item-inv" role="presentation">
              <button
                onClick={(e) => businessClick("business")}
                className="nav-link-inv  p-1"
                id="business-tab"
                data-bs-toggle="tab"
                data-bs-target="#business-tab-pane"
                type="button"
                role="tab"
                aria-controls="business-tab-pane"
                aria-selected="false"
              >
                <h3>Business KYC Submissions</h3>
              </button>
            </li>
            <li className="nav-item-inv" role="presentation">
              <button
                onClick={(e) => newInvestorIntrestsClick("newinvestment")}
                className="nav-link-inv p-1 "
                id="newinvestment-tab"
                data-bs-toggle="tab"
                data-bs-target="#newinvestment-tab-pane"
                type="button"
                role="tab"
                aria-controls="newinvestment-tab-pane"
                aria-selected="false"
              >
                <h3>Investors KYC Submissions</h3>
              </button>
            </li>
            <li>
              {
                (clickedTabMain === "business" || clickedTabMain === "newinvestment") && (
                  <input
                    id="all"
                    name="all"
                    type="text"
                    className="form-control rounded px-4 py-3 border-0 w-100"
                    placeholder="Search by keywords"
                    onChange={(e) => {
                      if (clickedTabMain === "business") {
                        handleChangeAllInputBus(e);
                      } else {
                        handleChangeAllInputInv(e);
                      }
                    }}
                  />
                )
              }

            </li>
          </ul>
        </div>
        <div
          className="tab-content idiv_inv_left_card_text pe-5 ps-5"
          id="myTabContent"
        >
          <div
            className="tab-pane fade show "
            id="onboarding-tab-pane"
            role="tabpanel"
            aria-labelledby="onboarding-tab"
            tabIndex="0"
          >
            {/* =====================onboarding================== */}


            <div className="compliance_top_tab ">
              <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                <li className="nav-item-inv mt-0" role="presentation">
                  <button
                    onClick={onBoardBusinessClick}
                    className="nav-link-inv-onboard p-1 active"
                    id="onboardingbusiness-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#onboardingbusiness-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="onboardingbusiness-tab-pane"
                    aria-selected="true"
                  >
                    <h3>Business </h3>
                  </button>
                </li>
                <li className="nav-item-inv mt-0" role="presentation">
                  <button
                    onClick={onBoardingInvestorClick}
                    className="nav-link-inv-onboard  p-1 "
                    id="onboardinginvestor-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#onboardinginvestor-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="onboardinginvestor-tab-pane"
                    aria-selected="false"
                  >
                    <h3>Investor</h3>
                  </button>
                </li>

              </ul>
            </div>

            <div
              className="tab-content idiv_inv_left_card_text  "
              id="myTabContent"
            >
              <div
                className="tab-pane fade show "
                id="onboardingbusiness-tab-pane"
                role="tabpanel"
                aria-labelledby="onboardingbusiness-tab"
                tabIndex="0"
              >

                <div>
                  <div className="row mb-3 mt-2 gap-3">

                    <Filters
                      className="col-md-2"
                      label={"Search by Business"}
                      htmlFor={"onboard_business"}
                      id={'onboard_business'}
                      name={"onboard_business"}
                      defaultvalue={defaultvalue}
                      data={uniqueOnBoardBusinessName}
                      selectedValue={filterValues.business}
                      onChange={handleChangeInput}
                    />
                    <Filters
                      className="col-md-2"
                      label={"Country"}
                      htmlFor={"onboard_country"}
                      id={'onboard_country'}
                      name={"onboard_country"}
                      defaultvalue={defaultvalue}
                      data={uniquelonBoardCountry}
                      selectedValue={filterValues.country}
                      onChange={handleChangeInput}
                    />
                    {/* <Filters
                label={"Contact Name"}
                htmlFor={"onboard_cont_name"}
                id={'onboard_cont_name'}
                name={"onboard_cont_name"}
                defaultvalue={defaultvalue}
                data={uniqueContactName}
                onChange={handleChangeInput}
                /> */}

                    <Filters
                      className="col-md-2"
                      label={"Type"}
                      htmlFor={"onboard_type"}
                      id={'onboard_type'}
                      name={"onboard_type"}
                      defaultvalue={defaultvalue}
                      data={uniqueOnboardBusType}
                      selectedValue={filterValues.type}
                      onChange={handleChangeInput} />

                    <Filters
                      className="col-md-2"
                      label={"Status"}
                      htmlFor={"status"}
                      id={'status'}
                      name={"status"}
                      defaultvalue={defaultvalue}
                      data={uniqueStatusType}
                      selectedValue={filterValues.status}
                      onChange={handleChangeInput} />

                    {/* <Filters
                label={"Ref No."}
                htmlFor={"onboard_refNo"}
                id={'onboard_refNo'}
                name={"onboard_refNo"}
                defaultvalue={defaultvalue}
                data={uniquelrefNo}
                onChange={handleChangeInput}
                /> */}

                    <div className=" col align-self-end">
                      <button className="blue_btn" onClick={clearFilters}>
                        Clear All Filters
                      </button>
                    </div>

                    <div className="col btn_style">
                      <button className="blue_btn " onClick={exportToExcelBusOnBoard} disabled={role_code === AUDITOR_ROLE}
                      >
                        Download XLS
                      </button>
                    </div>
                  </div>

                </div>

                <div className=" all_inv_newinv_table">
                  <Table
                    striped
                    // bordered
                    className="bg-white ps-4 pe-4 text-center "
                  >
                    <thead className=" Cpointer ">
                      <tr>
                        {columnsOnboardingBsns.map((column) => {
                          return (
                            <>
                              <th
                                key={column.field}
                                onClick={() => handleSort(column.field)}
                              >
                                {ltwo || loading ? (
                                  <Skeleton width={100} height={15} />
                                ) : (
                                  <div>
                                    {column.title !== "Actions" ? (
                                      <div
                                        className={`text-black  ${"text-start"

                                          }`}
                                      >
                                        {" "}
                                        {column.title}&#9662;
                                      </div>
                                    ) : (
                                      <div className="table_data_header_styl">
                                        {column.title}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </th>
                            </>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {onBoardFilter.map((business, index) => {
                        return (
                          <tr key={index} className="new_inv_business_table">

                            <td style={{ width: "250px" }}>
                              {business.business_name === undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                business.business_name
                              )}
                            </td>

                            <td>
                              {business.business_type === undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                business.business_type
                              )}
                            </td>

                            <td>
                              {business.phone === undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                business.phone
                              )}
                            </td>
                            <td>
                              {business.country == "undefined" ? (
                                ""
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                business.country
                              )}
                            </td>
                            <td>
                              {business.hear_about_us == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                business.hear_about_us
                              )}
                            </td>
                            <td>
                              {business.created_date_time == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                moment(business.created_date_time).format("DD-MM-YYYY")
                              )}
                            </td>

                            <td>
                              {business.onboard_status === undefined ? (
                                "-"
                              ) : (
                                <div
                                  style={{
                                    color: `${business.status === COMPLIANCE_APPROVED
                                      ? "Green"
                                      : business.status === COMPLIANCE_REJECTED
                                        ? "Red"
                                        : business.status === COMPLIANCE_PENDING
                                          ? "#3d79f3"
                                          : "Black"
                                      }`,
                                    fontWeight: "400",
                                  }}
                                  className="text-start`"
                                >
                                  {ltwo || loading ? (
                                    <Skeleton width={100} height={15} />
                                  ) : business.onboard_status === COMPLIANCE_PENDING ? (
                                    <div
                                      className="onboarding_pending_status"
                                    >
                                      Pending
                                    </div>
                                  )

                                    : business.onboard_status === COMPLIANCE_PENDING ? (
                                      <div
                                        // onClick={() =>
                                        //   setPendginLinkModal(
                                        //     true,
                                        //     pendingLinkDetails(business)
                                        //   )
                                        // }
                                        className="onboarding_pending_status"
                                      >
                                        Pending
                                      </div>
                                    )
                                      : business.onboard_status === COMPLIANCE_APPROVED ? (
                                        <div
                                          className="onboarding_approved_status"
                                        // onClick={() => handleDataTopass(business)}
                                        >
                                          Approved
                                        </div>
                                      ) : business.onboard_status === COMPLIANCE_REJECTED ? (
                                        <div className="compliance_rejected_status">
                                          Rejected
                                        </div>
                                      ) : (
                                        "-"
                                      )}
                                </div>
                              )}
                            </td>

                            <td>
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                <div className="compl_bus_actions_td">
                                  {business.onboard_status === COMPLIANCE_PENDING ? (
                                    <div>
                                      <img
                                        className="pe-3 Cpointer"
                                        src="./images/icons/blue_eye.svg"
                                        alt=""
                                        onClick={() =>
                                          setOnBoardingEyeDetailsModal(
                                            true,
                                            onBoardingApprovalLink(business)
                                          )
                                        }
                                      />
                                      {/* <img
                                    className="indiv_loan_dtls_eye Cpointer"
                                    src="./images/upload_icon.svg"
                                    alt=""
                                    onClick={() => handleDataTopass(business)}
                                  /> */}
                                    </div>
                                  ) : (business.onboard_status === COMPLIANCE_APPROVED ?
                                    (
                                      <div>
                                        <img
                                          className="pe-3 Cpointer"
                                          src="./images/icons/blue_eye.svg"
                                          alt=""
                                          onClick={() =>
                                            setOnBoardingEyeDetailsModal(
                                              true,
                                              onBoardingApprovalLink(business)
                                            )
                                          }

                                        />

                                      </div>) : ""

                                  )}
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>


              <div
                className="tab-pane fade show "
                id="onboardinginvestor-tab-pane"
                role="tabpanel"
                aria-labelledby="onboardinginvestor-tab"
                tabIndex="1"
              >
                <div className="row mb-3 mt-2 gap-3">

                  <Filters
                    className={"col"}
                    label={"Search by Company"}
                    htmlFor={"inv_comp_name_onboard"}
                    id={'inv_comp_name_onboard'}
                    name={"inv_comp_name_onboard"}
                    defaultvalue={defaultvalue}
                    data={uniqueInvestorCompanyNameOnBoard}
                    selectedValue={filterValues.invCompany}
                    onChange={handleChangeInput}
                  />

                  <Filters
                    className={"col"}
                    label={"Ref No."}
                    htmlFor={"inv_refNo_onboard"}
                    id={'inv_refNo_onboard'}
                    name={"inv_refNo_onboard"}
                    defaultvalue={defaultvalue}
                    data={uniqueInvRefNoOnBoard}
                    selectedValue={filterValues.invRefNo}
                    onChange={handleChangeInput}
                  />

                  <Filters
                    className={"col"}
                    label={"Country"}
                    htmlFor={"inv_country_onboard"}
                    id={'inv_country_onboard'}
                    name={"inv_country_onboard"}
                    defaultvalue={defaultvalue}
                    data={uniqueInvCountryOnBoard}
                    selectedValue={filterValues.invCountry}
                    onChange={handleChangeInput}
                  />


                  <Filters
                    className={"col"}
                    label={"Contact Name"}
                    htmlFor={"inv_contct_onboard"}
                    id={'inv_contct_onboard'}
                    name={"inv_contct_onboard"}
                    defaultvalue={defaultvalue}
                    data={uniqueInvContctOnBoard}
                    selectedValue={filterValues.invContact}
                    onChange={handleChangeInput}
                  />

                  <Filters
                    className="col-md-2"
                    label={"Status"}
                    htmlFor={"invStatus"}
                    id={'invStatus'}
                    name={"invStatus"}
                    defaultvalue={defaultvalue}
                    data={uniqueStatusType}
                    selectedValue={filterValues.invStatus}
                    onChange={handleChangeInput} />

                  <div className=" col align-self-end">
                    <button className="blue_btn" onClick={clearFilters}>
                      Clear All Filters
                    </button>
                  </div>

                  <div className="col btn_style">
                    <button className="blue_btn " onClick={exportToExcelInvOnBoard} disabled={role_code === AUDITOR_ROLE}>
                      Download XLS
                    </button>
                  </div>
                </div>

                <div className="compliance_tab_height">
                  <Table striped className="bg-white ps-4 pe-4 text-center ">
                    <thead className="">
                      <tr>
                        {columnsOnBoardInv.map((column) => {
                          return (
                            <>
                              <th className="text-start"
                                key={column.field}
                                onClick={() => handleSorttwo(column.field)}
                              >
                                {ltwo || loading ? (
                                  <Skeleton width={100} height={15} />
                                ) : (
                                  <div>
                                    {column.title !== "Actions" ? (
                                      <div className="text-black table_data_header_styl">
                                        {" "}
                                        {column.title}&#9662;
                                      </div>
                                    ) : (
                                      column.title
                                    )}
                                  </div>
                                )}
                              </th>
                            </>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {investorOnBoardFilter.map((data, index) => {


                        return (
                          <tr key={index} className="new_inv_interst_table">
                            <td>
                              {data.investor_reference_no == undefined ? (
                                "-"
                              ) : (
                                <div className="">
                                  {ltwo || loading ? (
                                    <Skeleton width={100} height={15} />
                                  ) : (
                                    data.investor_reference_no
                                  )}
                                </div>
                              )}
                            </td>
                            <td>
                              {data.investor_company_name == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                data.investor_company_name
                              )}
                            </td>
                            <td>
                              {data.type == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                data.type
                              )}
                            </td>
                            <td>
                              {data.investor_name == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                data.investor_name
                              )}
                            </td>
                            <td>
                              {data.phone == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                data.phone
                              )}
                            </td>
                            <td>
                              {data.country == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                data.country
                              )}
                            </td>
                            <td>
                              {data.created_date_time == undefined ? (
                                "-"
                              ) : ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                <div>

                                  {
                                    moment(data.created_date_time).format("DD-MMM-YYYY")
                                  }
                                </div>
                              )}
                            </td>
                            <td>
                              {data.onboard_status === undefined ? (
                                "-"
                              ) : (
                                <div
                                  style={{
                                    color: `${data.status === COMPLIANCE_APPROVED
                                      ? "Green"
                                      : data.status === COMPLIANCE_REJECTED
                                        ? "Red"
                                        : data.status === COMPLIANCE_PENDING
                                          ? "#3d79f3"
                                          : "Black"
                                      }`,
                                    fontWeight: "400",
                                  }}
                                >
                                  {ltwo || loading ? (
                                    <Skeleton width={100} height={15} />
                                  ) : data.onboard_status == COMPLIANCE_PENDING ? (
                                    <div

                                      className="onboarding_pending_status"
                                    >
                                      Pending
                                    </div>
                                  ) : data.onboard_status === COMPLIANCE_APPROVED ? (
                                    <div className="compliance_inv_approved_status">
                                      Approved
                                    </div>
                                  ) : data.onboard_status === COMPLIANCE_REJECTED ? (
                                    <div className="compliance_rejected_status">
                                      Rejected
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              )}
                            </td>

                            <td className="text-center">
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                <div>
                                  {data.onboard_status === COMPLIANCE_PENDING ? (
                                    <img
                                      className="indiv_loan_dtls_eye Cpointer"
                                      src="./images/icons/blue_eye.svg"
                                      alt=""
                                      onClick={() =>
                                        setIndivInvestorDetailsModal(
                                          true,
                                          handleDatatoinvDetailModal(data)
                                        )
                                      }
                                    />
                                  ) : data.onboard_status === COMPLIANCE_APPROVED ? (
                                    <img
                                      className="indiv_loan_dtls_eye Cpointer"
                                      // src="./images/close_icon.svg"
                                      src="./images/icons/blue_eye.svg"
                                      alt=""
                                      onClick={() =>
                                        setIndivInvestorDetailsModal(
                                          true,
                                          handleDatatoinvDetailModal(data)
                                        )
                                      }

                                    />
                                  )
                                    : ""
                                  }
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>

              </div>

            </div>












          </div>
          {/* =====================Business Submission================== */}

          <div
            className="tab-pane fade show "
            id="business-tab-pane"
            role="tabpanel"
            aria-labelledby="business-tab"
            tabIndex="0"
          >
            <div>
              <div className="row mb-3 mt-2 gap-3">



                <Filters
                  className={"col"}
                  label={"Search by Business"}
                  htmlFor={"business"}
                  id={'business'}
                  name={"business"}
                  defaultvalue={defaultvalue}
                  data={uniqueBusinessName}
                  onChange={handleChangeInput}
                  selectedValue={filterValues.businessSubName}
                />
                <Filters
                  className={"col"}
                  label={"Country"}
                  htmlFor={"country"}
                  id={'country'}
                  name={"country"}
                  defaultvalue={defaultvalue}
                  data={uniquelCountry}
                  onChange={handleChangeInput}
                  selectedValue={filterValues.businessSubCountry}
                />
                <Filters
                  className={"col"}
                  label={"Contact Name"}
                  htmlFor={"cont_name"}
                  id={'cont_name'}
                  name={"cont_name"}
                  defaultvalue={defaultvalue}
                  data={uniqueContactName}
                  onChange={handleChangeInput}
                  selectedValue={filterValues.businessSubContact}
                />

                <Filters
                  className={"col"}
                  label={"Type"}
                  htmlFor={"type"}
                  id={'type'}
                  name={"type"}
                  defaultvalue={defaultvalue}
                  data={uniqueType}
                  onChange={handleChangeInput}
                  selectedValue={filterValues.businessSubType}
                />


                <Filters
                  className={"col"}
                  label={"Ref No."}
                  htmlFor={"refNo"}
                  id={'refNo'}
                  name={"refNo"}
                  defaultvalue={defaultvalue}
                  data={uniquelrefNo}
                  onChange={handleChangeInput}
                  selectedValue={filterValues.businessSubRefNo}
                />

                <div className=" col align-self-end">
                  <button className="blue_btn" onClick={clearFilters}>
                    Clear All Filters
                  </button>
                </div>

                <div className="col btn_style">
                  <button className="blue_btn " onClick={exportToExcel} disabled={role_code === AUDITOR_ROLE}>
                    Download XLS
                  </button>
                </div>
              </div>
            </div>
            <div className="all_inv_newinv_table">
              <Table
                striped
                // bordered
                className="bg-white ps-4 pe-4 text-center "
              >
                <thead className=" Cpointer all_inv_newinv_table">
                  <tr>
                    {columns.map((column) => {
                      return (
                        <>
                          <th
                            key={column.field}
                            onClick={() => handleSort(column.field)}
                          >
                            {ltwo || loading ? (
                              <Skeleton width={100} height={15} />
                            ) : (
                              <div>
                                {column.title !== "Actions" ? (
                                  <div
                                    className={`text-black  ${"text-start"

                                      }`}
                                  >
                                    {" "}
                                    {column.title}&#9662;
                                  </div>
                                ) : (
                                  <div className="table_data_header_styl">
                                    {column.title}
                                  </div>
                                )}
                              </div>
                            )}
                          </th>
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {invInterestFilter.map((business, index) => {
                    return (
                      <tr key={index} className="new_inv_business_table">
                        <td>
                          {business.business_reference_no === undefined ? (
                            "-"
                          ) : (
                            <div className="">
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                business.business_reference_no
                              )}
                            </div>
                          )}
                        </td>
                        <td style={{ width: "250px" }}>
                          {business.business_name === undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            business.business_name
                          )}
                        </td>
                        <td style={{ width: "250px" }}>
                          {business.user_name === undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            business.user_name
                          )}
                        </td>

                        <td>
                          {business.business_type === undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            business.business_type
                          )}
                        </td>

                        <td>
                          {business.phone === undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            business.phone
                          )}
                        </td>
                        <td>
                          {business.country == "undefined" ? (
                            ""
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            business.country
                          )}
                        </td>

                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : business?.kyc_forms?.length === 0 ? (
                            <div style={{ color: "#FF9209" }} className="fw-bolder">KYC need to upload</div>
                          ) : (
                            <div
                              style={{
                                color: `${business.status === COMPLIANCE_APPROVED
                                  ? "Green"
                                  : business.status === COMPLIANCE_REJECTED
                                    ? "Red"
                                    : business.status === COMPLIANCE_PENDING
                                      ? "#3d79f3"
                                      : "Black"
                                  }`,
                                fontWeight: "400",
                              }}
                              className="text-start`"
                            >
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : business?.kyc_forms[0]?.status === COMPLIANCE_PENDING ? (
                                <div

                                  className="onboarding_pending_status"
                                >
                                  Pending
                                </div>
                              ) : business?.kyc_forms[0]?.status === COMPLIANCE_APPROVED ? (
                                <div
                                  className="compliance_approved_status"
                                  onClick={() => handleDataTopass(business)}
                                >
                                  Approved
                                </div>
                              ) : business?.kyc_forms[0]?.status === COMPLIANCE_REJECTED ? (
                                <div className="compliance_rejected_status">
                                  Rejected
                                </div>
                              ) : (
                                "-"
                              )}
                            </div>
                          )}
                        </td>

                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <div className="compl_bus_actions_td_business_kyc pe-2">

                              <div>
                                {business?.kyc_forms?.length > 0 && <img
                                  className="pe-2 Cpointer"
                                  style={{ width: "30px" }}
                                  src="./images/icons/kyc_blue.svg"
                                  alt=""
                                  onClick={() => setKycDetailsModal(true, kycLink(business))}

                                />}
                                <img
                                  className="pe-2 Cpointer"
                                  style={{ width: "30px" }}
                                  src="./images/icons/blue_eye.svg"
                                  alt=""
                                  onClick={() =>
                                    setApprovedEyeDetailsModal(
                                      true,
                                      approvedLinkDetails(business)
                                    )
                                  }
                                />
                                <img
                                  className="indiv_loan_dtls_eye Cpointer"
                                  style={{ width: "20px" }}
                                  src="./images/upload_icon.svg"
                                  alt=""
                                  onClick={() => handleDataTopass(business)}
                                />
                              </div>

                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>

          {/* =====================Business Submission================== */}

          <div
            className="tab-pane fade show"
            id="newinvestment-tab-pane"
            role="tabpanel"
            aria-labelledby="newinvestment-tab"
            tabIndex="0"
          >
            <div className="row mb-3 mt-2 gap-3">

              <Filters
                className={"col"}
                label={"Search by Investor"}
                htmlFor={"inv_comp_name"}
                id={'inv_comp_name'}
                name={"inv_comp_name"}
                defaultvalue={defaultvalue}
                data={uniqueInvestorCompanyName}
                onChange={handleChangeInput}
                selectedValue={filterValues.invSubName}
              />

              <Filters
                className={"col"}
                label={"Ref No."}
                htmlFor={"inv_refNo"}
                id={'inv_refNo'}
                name={"inv_refNo"}
                defaultvalue={defaultvalue}
                data={uniqueInvRefNo}
                onChange={handleChangeInput}
                selectedValue={filterValues.invSubRefNo}
              />

              <Filters
                className={"col"}
                label={"Country"}
                htmlFor={"inv_country"}
                id={'inv_country'}
                name={"inv_country"}
                defaultvalue={defaultvalue}
                data={uniqueInvCountry}
                onChange={handleChangeInput}
                selectedValue={filterValues.invSubCountry}
              />


              <Filters
                className={"col"}
                label={"Contact Name"}
                htmlFor={"inv_contct"}
                id={'inv_contct'}
                name={"inv_contct"}
                defaultvalue={defaultvalue}
                data={uniqueInvContct}
                onChange={handleChangeInput}
                selectedValue={filterValues.invSubCont_name}
              />



              <Filters
                className="col"
                label="Maximum Investment"
                htmlFor="inv_maxinv_onboard"
                id="inv_maxinv_onboard"
                name="inv_maxinv_onboard"
                defaultvalue={defaultvalue}
                data={investmentRanges}
                selectedValue={filterValues.maxInvestment}
                onChange={handleChangeInput}
              />

              <div className=" col align-self-end">
                <button className="blue_btn" onClick={clearFilters}>
                  Clear All Filters
                </button>
              </div>

              <div className="col btn_style">
                <button className="blue_btn " onClick={exportToExcelInv} disabled={role_code === AUDITOR_ROLE}>
                  Download XLS
                </button>
              </div>
            </div>

            <div className="compliance_tab_height">
              <Table striped className="bg-white ps-4 pe-4 text-center all_inv_newinv_table">
                <thead className="">
                  <tr>
                    {columnstwo.map((column) => {
                      return (
                        <>
                          <th
                            key={column.field}
                            onClick={() => handleSorttwo(column.field)}
                          >
                            {ltwo || loading ? (
                              <Skeleton width={100} height={15} />
                            ) : (
                              <div>
                                {column.title !== "Actions" ? (
                                  <div className="text-black  text-start">
                                    {" "}
                                    {column.title}&#9662;
                                  </div>
                                ) : (
                                  column.title
                                )}
                              </div>
                            )}
                          </th>
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {investorSubmissionFilter?.map((data, index) => {
                    let exp_doc = 0;
                    let first_exp_date;
                    data.list_of_documents?.map((each_doc) => {
                      if (each_doc.is_expired === true) {
                        exp_doc = exp_doc + 1;
                      }
                      if (
                        data.list_of_expired_docs &&
                        data.list_of_expired_docs.length > 0
                      ) {
                        let minimum_expiry_date =
                          data.list_of_expired_docs[0].expiry_date;
                        data.list_of_expired_docs?.map((current) => {
                          if (minimum_expiry_date > current.expiry_date) {
                            minimum_expiry_date = current.expiry_date;
                          }
                        });
                        first_exp_date = minimum_expiry_date;
                      }
                    });
                    return (
                      <tr key={index} className="new_inv_interst_table">
                        <td>
                          {data.investor_name == undefined ? (
                            "-"
                          ) : (
                            <div className="">
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                data.investor_reference_no
                              )}
                            </div>
                          )}
                        </td>
                        <td>
                          {data.investor_company_name == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.investor_company_name
                          )}
                        </td>
                        <td>
                          {data.type == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.type
                          )}
                        </td>
                        <td>
                          {data.investor_name == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.investor_name
                          )}
                        </td>
                        <td>
                          {data.phone == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.phone
                          )}
                        </td>
                        <td>
                          {data.country == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            data.country
                          )}
                        </td>
                        <td>
                          {data.committed_principal == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <div>
                              ${" "}
                              {Number(
                                data.committed_principal
                              ).toLocaleString()}
                            </div>
                          )}
                        </td>
                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : data?.kyc_forms?.length === 0 ? (
                            <div style={{ color: "#FF9209" }} className="fw-bolder">KYC need to upload</div>
                          ) : (
                            <div
                              style={{
                                color: `${data.status === COMPLIANCE_APPROVED
                                  ? "Green"
                                  : data.status === COMPLIANCE_REJECTED
                                    ? "Red"
                                    : data.status === COMPLIANCE_PENDING
                                      ? "#3d79f3"
                                      : "Black"
                                  }`,
                                fontWeight: "400",
                              }}
                              className="text-start`"
                            >
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : data?.kyc_forms && data?.kyc_forms[0]?.status === COMPLIANCE_PENDING ? (
                                <div
                                  // onClick={() =>
                                  //   setPendginLinkModal(
                                  //     true,
                                  //     pendingLinkDetails(data)
                                  //   )
                                  // }
                                  className="onboarding_pending_status"
                                >
                                  Pending
                                </div>
                              ) : data?.kyc_forms && data?.kyc_forms[0]?.status === COMPLIANCE_APPROVED ? (
                                <div
                                  className="compliance_inv_approved_status"
                                // onClick={() => handleDataTopass(data)}
                                >
                                  Approved
                                </div>
                              ) : data?.kyc_forms[0]?.status === COMPLIANCE_REJECTED ? (
                                <div className="compliance_rejected_status">
                                  Rejected
                                </div>
                              ) : (
                                "-"
                              )}
                            </div>
                          )}
                        </td>


                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <div className="compl_bus_actions_td_business_kyc text-center pe-3">

                              <div>
                                {data?.kyc_forms?.length > 0 && <img
                                  className="pe-2 Cpointer"
                                  style={{ width: "30px" }}
                                  src="./images/icons/kyc_blue.svg"
                                  alt=""
                                  onClick={() => setKycDetailsModal(true, kycLink(data))}

                                />}
                                <img
                                  className="pe-2 Cpointer"
                                  style={{ width: "30px" }}
                                  src="./images/icons/blue_eye.svg"
                                  alt=""
                                  onClick={() =>
                                    setApprovedEyeDetailsModal(
                                      true,
                                      approvedLinkDetails(data)
                                    )
                                  }
                                />
                                <img
                                  className="indiv_loan_dtls_eye Cpointer"
                                  style={{ width: "20px" }}
                                  src="./images/upload_icon.svg"
                                  alt=""
                                  onClick={() => handleDataTopass(data)}
                                />
                              </div>

                            </div>
                          )}
                        </td>


                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>

        </div>
      </div>
      <InvestorDetailsModal
        data={invModalData}
        show={investorDetailsModal}
        onHide={() => setInvestorDetailsModal(false)}
        role_code={role_code}
      />
      <IndivInvestorDetailsModal
        data={invModalData}
        show={indivInvestorDetailsModal}
        onHide={() => setIndivInvestorDetailsModal(false)}
        role_code={role_code}
      />
      <InvestorApprovedDetailsModal
        data={invApprovedModalData}
        show={investorApprovedModal}
        onHide={() => setInvestorApprovedModal(false)}
        role_code={role_code}
      />

      <QuarterlyCallReport
        data={businessDetailsMomReport}
        quarterlyMomReports={quarterlyMomReports}
        show={modalLoanDetailsShow}
        onHide={() => setModalLoanDetailsShow(false)}
        role_code={role_code}
      />
      <PendingLinkModal
        getDocuments={getDocuments}
        singleBsnsData={masterBusinessData}
        data={pendingLinkData}
        show={pendginLinkModal}
        onHide={() => setPendginLinkModal(false)}
        role_code={role_code}
        bname={businessNameData}
        riskAssessmentCompleted={riskAssessmentCompleted}
      />
      <KycDetailsModal
        data={kycLinkData}
        show={kycDetailsModal}
        onHide={() => setKycDetailsModal(false)}
        role_code={role_code}
      />
      <ApprovedEyeDetailsModal
        data={approvedLinkData}
        show={approvedEyeDetailsModal}
        onHide={() => setApprovedEyeDetailsModal(false)}
        role_code={role_code}
      />
      <OnboardingApprovalModal
        data={onBoardingLinkData}
        show={onBoardingEyeDetailsModal}
        onHide={() => setOnBoardingEyeDetailsModal(false)}
        role_code={role_code}
      />
    </div>
  );
};

export default Compliance;

export const InvestorApprovedDetailsModal = (props) => {
  let quarterlyMomReports = props.quarterlymomreports?.mom_reports;
  let data = props.data;
  let ltwo = props.ltwo;
  let loading = props.loading;

  const handleClose = () => {
    props.onHide();
  };

  const [investorNotes, setInvestorNotes] = useState("");
  const handleInvestorNotes = (e) => {
    let value = e.target.value;
    if (value === undefined || value === "" || value === null) {
      setInvestorNotes("");
    } else setInvestorNotes(e.target.value);
  };
  const saveQcr = () => {
    let myObject = {
      investor_id: data.investor_id,
      admin_user_id: Cookies.get("admin_user_id"),
      admin_user_name: Cookies.get("admin_user_name"),
      admin_notes: investorNotes,
      is_reviewed: 1,
    };
    axios
      .post(
        base_url + "investor-quarterly-call-reports/save_review_notes",
        myObject
      )
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Saved Successfully", {
            toastId: 4,
          });
          props.onHide();
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Quarterly Call Reports</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="px-4 py-2"
        style={{ height: "28rem", overflow: "auto" }}
      >
        <div className="container p-0 pb-3">
          <div className="row">
            <div className="col">
              <div className="mb-3">
                <p className="text_st ">Investor Company Name</p>
                <span className="bolder_text ">
                  {data.investor_company_name === undefined ||
                    data.investor_company_name === ""
                    ? "-"
                    : data.investor_company_name}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Status</p>
                <span className="bolder_text ">
                  {data.status === COMPLIANCE_PENDING
                    ? "Pending"
                    : data.status === COMPLIANCE_APPROVED
                      ? "Approved"
                      : data.status === COMPLIANCE_REJECTED
                        ? "Rejected"
                        : "-"}
                </span>
              </div>
            </div>
            <div className="col ms-3 ">
              <div className="mb-3">
                <p className="text_st ">Investor Name</p>
                <span className="bolder_text ">
                  {data.investor_name === undefined || data.investor_name === ""
                    ? "-"
                    : data.investor_name}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Maximum Investment</p>
                <span className="bolder_text ">
                  {data.committed_principal === undefined ||
                    data.committed_principal === ""
                    ? "-"
                    : "$ " + Number(data.committed_principal).toLocaleString()}
                </span>
              </div>

            </div>
            <div className="col ">
              <div className="mb-3">
                <p className="text_st ">Phone</p>
                <span className="bolder_text ">
                  {data.phone === undefined || data.phone === ""
                    ? "-"
                    : data.phone}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Type</p>
                <span className="bolder_text ">
                  {data.type === undefined || data.type === ""
                    ? "-"
                    : data.type}
                </span>
              </div>
            </div>


            <div className="row mt-2 invcompliance_qcr_notes">
              <p className="text_st mb-1">Notes</p>
              <Form>
                <Form.Group
                  className=" "
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    size="lg"
                    className="ANLtextarea "
                    name="textarea"
                    as="textarea"
                    rows={2}
                    placeholder={
                      "Any details required to store for the documents of the Investor can be noted here."
                    }
                    onChange={handleInvestorNotes}
                  />
                </Form.Group>
              </Form>

              <hr />
              <label>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  style={{ transform: "scale(1.5)", border: "none" }}
                />
                <b className="kyc_confirmation">
                  I have validated that this investor has cleared the KYC Review
                </b>
              </label>
            </div>
          </div>
        </div>
        {data.is_reviewed === 0 && data.new_investor === 0 ? (
          <div className="kyc_close_to_expry_txt ">
            <img src="./images/exclamationmark.svg" alt="" className="me-2" />
            It’s been close to a year from the last review. Arrange a fresh
            review!
          </div>
        ) : data.is_reviewed === 0 && data.new_investor === 1 ? (
          <div className="kyc_close_to_expry_txt ">
            <img
              src="./images/exclamationmark.svg"
              alt=""
              className="me-2 mb-2"
            />
            Please review
          </div>
        ) : (
          ""
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3   ">
        <div className="">
          <button
            className="btn btn_background px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>

        <div>
          <button
            className="btn blue_btn me-3 px-4 py-2"
            disabled={isChecked ? false : true}
            onClick={saveQcr}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export const IndivInvestorDetailsModal = (props) => {
  let quarterlyMomReports = props.quarterlyMomReports?.mom_reports;
  let data = props.data;
  const [fillingFormModal, setFillingFormModal] = useState(false);
  const [filledupViewModal, setFilledupViewModal] = useState(false);
  const [quarterlyMomReptsFilter, setQuarterlyMomReptsFilter] = useState([]);
  const navigate = useNavigate();

  const handleClose = () => {
    props.onHide();
    setUploadFile(null);
    setUploadedUrl(null);
    setUpload(false);
    setInvestorUserName("")
  };
  useEffect(() => {
    if (quarterlyMomReports !== undefined) {
      setQuarterlyMomReptsFilter(quarterlyMomReports);
    }
  }, [quarterlyMomReports]);

  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const titles = [
    { title: "MOM ID", sort: "mom_reference_no" },
    { title: "MOM Report", sort: "" },
    { title: "Uploaded Date", sort: "meeting_date" },
  ];





  const [indivMomRefData, setIndivMomRefData] = useState([]);

  const momRefNo = (doc) => {
    setIndivMomRefData(doc);
  };

  const [investorNotes, setInvestorNotes] = useState("");
  const handleInvestorNotes = (e) => {
    let value = e.target.value;
    if (value === undefined || value === "" || value === null) {
      setInvestorNotes("");
    } else setInvestorNotes(e.target.value);
  };

  const [investorUserName, setInvestorUserName] = useState("");
  const handleChangeInputusername = (e) => {
    setInvestorUserName(e.target.value);
  };

  const [invLoading, setInvLoading] = useState(false)

  const approveInvestor = () => {
    const fd1 = new FormData();
    if (investorUserName === "") {
      toast.error("Please input investor username", {
        toastId: 103,
      });
    } else {
      fd1.append("investor_id", data.investor_id);
      fd1.append("admin_user_id", Cookies.get("admin_user_id"));
      fd1.append("admin_notes", investorNotes);
      fd1.append("upload_form", []);
      fd1.append("validated_by", Cookies.get("admin_user_name"));
      fd1.append("user_name", investorUserName);
      if (url != null) {
        const fileName = file;
        const lastDotIndex = fileName.lastIndexOf(".");
        const fileExtension = fileName.substring(lastDotIndex + 1);

        fd1.append("file", url, fileExtension);
      }
      setInvLoading(true)
      axios
        .post(base_url + "investor-master/approve_investor", fd1, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            toast.success("Investor Approved Successfully", {
              toastId: 4,
            });
            props.onHide();
            setTimeout(() => {
              window.location.reload();
            }, 800);
            setInvLoading(false)

          }
        });
    }
  };

  const rejectInvestor = () => {
    const fd1 = new FormData();
    fd1.append("investor_id", data.investor_id);
    fd1.append("admin_user_id", Cookies.get("admin_user_id"));
    fd1.append("admin_notes", investorNotes);
    fd1.append("upload_form", []);
    fd1.append("validated_by", Cookies.get("admin_user_name"));
    if (url != null) {
      const fileName = file;
      const lastDotIndex = fileName.lastIndexOf(".");
      const fileExtension = fileName.substring(lastDotIndex + 1);

      fd1.append("file", url, fileExtension);
    }
    axios
      .post(base_url + "investor-master/reject_investor", fd1, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Rejected Successfully", {
            toastId: 4,
          });
          setShowInv(false)
          props.onHide();
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  const [showInv, setShowInv] = useState(false);
  const handleShowRejectInv = () => setShowInv(true);
  const handleCloseRejectCloseInv = () => {
    setShowInv(false);
  };

  const [isUpload, setUpload] = useState(false);
  const [file, setUploadFile] = useState(null);
  const [url, setUploadedUrl] = useState(null);


  const handleChangeDownload = (event, file) => {
    const fileUrl = URL.createObjectURL(url);
    window.open(fileUrl, "_blank");
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Investor Details</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={`${invLoading ? 'px-4' : "px-4 py-2"}`}
        style={{
          height: data.onboard_status === COMPLIANCE_APPROVED ? "20rem" : "28rem",
          overflow: "auto",
        }}
      >
        <div className={invLoading ? "onClickApplyLoaderStyl" : "d-none"}>
          <ThreeDots
            height="60"
            width="60"
            radius="9"
            color="#3d79f3"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={invLoading}
          />
        </div>
        <div className="container p-0 pb-3">
          <div className="row">
            <div className="col me-2 compliance_bd_ab">
              <div className="mb-3">
                <p className="text_st ">Investor Company Name</p>
                <span className="bolder_text ">
                  {data.investor_company_name === undefined ||
                    data.investor_company_name === ""
                    ? "-"
                    : data.investor_company_name}
                </span>
              </div>

            </div>





            <div className="col compliance_bd_ab">
              <div className="mb-3">
                <p className="text_st ">Investor Name</p>
                <span className="bolder_text ">
                  {data.investor_name === undefined || data.investor_name === ""
                    ? "-"
                    : data.investor_name}
                </span>
              </div>

            </div>
            <div className="col compliance_bd_ab">
              <div className="mb-3">
                <p className="text_st ">
                  Country of Residence</p>
                <span className="bolder_text ">
                  {data.country === undefined || data.country === ""
                    ? "-"
                    : data.country}
                </span>
              </div>
            </div>



            <div className="row">

              <div className="col me-2 compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Email</p>
                  <span className="bolder_text ">
                    {data.email ? data.email : "-"}
                  </span>
                </div>
              </div>


              <div className="col me-2 compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Phone</p>
                  <span className="bolder_text ">
                    {data.phone === undefined || data.phone === ""
                      ? "-"
                      : data.phone}
                  </span>
                </div>
              </div>

              <div className="col compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Type</p>
                  <span className="bolder_text ">
                    {data.type === undefined || data.type === ""
                      ? "-"
                      : data.type}
                  </span>
                </div>
              </div>

            </div>
            <div className="row">
              <div className="col me-2 compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Nationality</p>
                  <span className="bolder_text ">
                    {data.nationality ? data.nationality : "-"}
                  </span>
                </div>
              </div>

              <div className="col me-2 compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Source of Fund</p>
                  <span className="bolder_text ">
                    {data.sourse_of_fund === undefined || data.sourse_of_fund === ""
                      ? "-"
                      : data.sourse_of_fund}
                  </span>
                </div>
              </div>

              <div className="col compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Where did you hear about us?</p>
                  <span className="bolder_text ">
                    {data.hear_about_us === undefined || data.hear_about_us === ""
                      ? "-"
                      : data.hear_about_us}
                  </span>
                </div>
              </div>

            </div>
            <div className="row">


              <div className="col me-2 compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Maximum Investment</p>
                  <span className="bolder_text ">
                    {data?.kyc_forms ? (!data.kyc_forms[0].committed_principal ? ("-") : "$ " + Number(data?.kyc_forms[0]?.committed_principal).toLocaleString()) : "-"}
                  </span>
                </div>
              </div>



              <div class="col me-2 compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Status</p>
                  <span className="bolder_text ">
                    {data.onboard_status === COMPLIANCE_PENDING
                      ? "Pending"
                      : data.onboard_status === COMPLIANCE_APPROVED
                        ? "Approved"
                        : data.onboard_status === COMPLIANCE_REJECTED
                          ? "Rejected"
                          : "-"}
                  </span>
                </div>
              </div>


              <div className="col compliance_bd_ab">
                <div className="mb-3">

                </div>
              </div>

            </div>

            {data.onboard_status === COMPLIANCE_APPROVED ? <div></div> :

              <hr />
            }
            {data.onboard_status === COMPLIANCE_APPROVED ? <div></div> :

              <div className="row d-flex justify-content-between mt-3">
                <div className="col invSubtextareafont">
                  <div className="col-lg-4">
                    <form className="form-group col mb-2  mt-0 custm_input_styl aksjdhf">
                      <label htmlFor="ulitmateholders">
                        <p>
                          {" "}
                          Enter Investor Username<span className="text-danger">*</span>

                        </p>
                      </label>
                      <input
                        type="text"
                        name="ulitmateholders"
                        id="disabledTextInput"
                        className="form-control bg-white"
                        onChange={handleChangeInputusername}
                      />
                    </form>
                  </div>

                  <p className="text_st mb-1">Comment<span style={{ color: "red" }}>*</span> </p>
                  <Form>
                    <Form.Group
                      className=" "
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Control
                        size="lg"
                        className="ANLtextarea "
                        name="textarea"
                        as="textarea"
                        rows={2}
                        placeholder="Comment here."
                        onChange={handleInvestorNotes}
                      />
                    </Form.Group>
                  </Form>

                  <div className="mt-3">
                    <div className="upload_file_name ">
                      <div
                        className="container d-flex gap-5"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={file}
                      >
                        <div>
                          {file != null
                            ? file.length > 25
                              ? file.slice(0, 25) + ".."
                              : file
                            : ""}
                        </div>
                        <div>
                          {file !== null && (
                            <a
                              style={{
                                display: "table-cell",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="fa-solid fa-eye text-primary fa-eye-font mt-2"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Click to view image"
                                onClick={(e) => handleChangeDownload(e, file)}
                              />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>

                    {isUpload && (
                      <div className="loader">
                        <ThreeDots
                          height="30"
                          width="30"
                          radius="9"
                          color="#3D79F3"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClassName=""
                          visible={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </Modal.Body>
      {data.onboard_status === COMPLIANCE_APPROVED ? <div></div> :
        <Modal.Footer className="d-flex  ps-3   ">
          <div className="">
            <button
              className="btn btn_background px-3 py-2"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
          <div>
            <button
              className="btn mx-2 py-2 px-3"
              style={{ backgroundColor: "#ED5151", color: "white" }}
              disabled={investorNotes == '' || props.role_code === AUDITOR_ROLE}
              variant="secondary"
              onClick={handleShowRejectInv}
            >
              Reject Investor
            </button>
          </div>

          <div>
            <button
              className="btn blue_btn me-3 px-4 py-2"
              disabled={investorNotes == '' || props.role_code === AUDITOR_ROLE}
              onClick={approveInvestor}
            >
              Approve Investor
            </button>
          </div>
        </Modal.Footer>
      }

      <FillingFormModal
        data={data}
        show={fillingFormModal}
        onHide={() => setFillingFormModal(false)}
      />
      <FilledupViewModal
        momrefno={momRefNo}
        data={indivMomRefData}
        show={filledupViewModal}
        onHide={() => setFilledupViewModal(false)}
      />

      <Modal show={showInv} onHide={handleCloseRejectCloseInv}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="alert_modal">
          Are you sure you want to reject?
        </Modal.Body>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectCloseInv}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={rejectInvestor}
          >
            Yes
          </button>
        </div>
      </Modal>
    </Modal>
  );
};
export const InvestorDetailsModal = (props) => {
  let quarterlyMomReports = props.quarterlyMomReports?.mom_reports;
  let data = props.data;
  const [fillingFormModal, setFillingFormModal] = useState(false);
  const [filledupViewModal, setFilledupViewModal] = useState(false);
  const [quarterlyMomReptsFilter, setQuarterlyMomReptsFilter] = useState([]);

  const navigate = useNavigate();

  const handleClose = () => {
    props.onHide();
    setUploadFile(null);
    setUploadedUrl(null);
    setUpload(false);
    setInvestorUserName("")
  };
  useEffect(() => {
    if (quarterlyMomReports !== undefined) {
      setQuarterlyMomReptsFilter(quarterlyMomReports);
    }
  }, [quarterlyMomReports]);

  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const titles = [
    { title: "MOM ID", sort: "mom_reference_no" },
    { title: "MOM Report", sort: "" },
    { title: "Uploaded Date", sort: "meeting_date" },
  ];

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...quarterlyMomReports].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setQuarterlyMomReptsFilter(sortedData);
  };



  const [indivMomRefData, setIndivMomRefData] = useState([]);

  const momRefNo = (doc) => {
    setIndivMomRefData(doc);
  };

  const [investorNotes, setInvestorNotes] = useState("");
  const handleInvestorNotes = (e) => {
    let value = e.target.value;
    if (value === undefined || value === "" || value === null) {
      setInvestorNotes("");
    } else setInvestorNotes(e.target.value);
  };

  const [investorUserName, setInvestorUserName] = useState("");
  const handleChangeInputusername = (e) => {
    setInvestorUserName(e.target.value);
  };

  const [invLoading, setInvLoading] = useState(false)


  const approveIndivInvestorKYC = () => {
    const fd1 = new FormData();

    fd1.append("investor_id", data.investor_id);
    fd1.append("investor_kyc_id", data.kyc_forms && (data.kyc_forms[0]?.investor_kyc_id));
    fd1.append("admin_user_id", Cookies.get("admin_user_id"));
    fd1.append("admin_notes", investorNotes);
    fd1.append("validated_by", Cookies.get("admin_user_name"));
    // fd1.append("upload_form", []);

    if (url != null) {
      const fileName = file;
      const lastDotIndex = fileName.lastIndexOf(".");
      const fileExtension = fileName.substring(lastDotIndex + 1);

      fd1.append("file", url, fileExtension);
    }
    setInvLoading(true)
    axios
      .post(base_url + "investor-master/approve_investor_kyc", fd1, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Investor Approved Successfully", {
            toastId: 4,
          });
          props.onHide();
          setTimeout(() => {
            window.location.reload();
          }, 800);
          setInvLoading(false)

        }
      });

  };


  const rejectInvestorKYC = () => {

    const fd1 = new FormData();
    fd1.append("investor_id", data.investor_id);
    fd1.append("investor_kyc_id", data.kyc_forms[0]?.investor_kyc_id);
    fd1.append("admin_user_id", Cookies.get("admin_user_id"));
    fd1.append("admin_notes", investorNotes);
    // fd1.append("upload_form", []);
    fd1.append("validated_by", Cookies.get("admin_user_name"));
    if (url != null) {
      const fileName = file;
      const lastDotIndex = fileName.lastIndexOf(".");
      const fileExtension = fileName.substring(lastDotIndex + 1);

      fd1.append("file", url, fileExtension);
    }
    axios
      .post(base_url + "investor-master/reject_investor_kyc", fd1, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("KYC Rejected Successfully", {
            toastId: 4,
          });
          setShowInv(false)
          props.onHide();
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  const [showInv, setShowInv] = useState(false);
  const handleShowRejectInv = () => setShowInv(true);
  const handleCloseRejectCloseInv = () => {
    setShowInv(false);
  };

  const [isUpload, setUpload] = useState(false);
  const [file, setUploadFile] = useState(null);
  const [url, setUploadedUrl] = useState(null);


  const handleChangeDownload = (event, file) => {
    const fileUrl = URL.createObjectURL(url);
    window.open(fileUrl, "_blank");
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Investor Details</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={`${invLoading ? 'px-4' : "px-4 py-2"}`}
        style={{ height: "28rem", overflow: "auto" }}
      >
        <div className={invLoading ? "onClickApplyLoaderStyl" : "d-none"}>
          <ThreeDots
            height="60"
            width="60"
            radius="9"
            color="#3d79f3"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={invLoading}
          />
        </div>
        <div className="container p-0 pb-3">
          <div className="row">
            <div className="col me-4 ">
              <div className="mb-3">
                <p className="text_st ">Investor Company Name</p>
                <span className="bolder_text ">
                  {data.investor_company_name === undefined ||
                    data.investor_company_name === ""
                    ? "-"
                    : data.investor_company_name}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Status</p>
                <span className="bolder_text ">
                  {data.onboard_status === COMPLIANCE_PENDING
                    ? "Pending"
                    : data.onboard_status === COMPLIANCE_APPROVED
                      ? "Approved"
                      : data.onboard_status === COMPLIANCE_REJECTED
                        ? "Rejected"
                        : "-"}
                </span>
              </div>
            </div>
            <div className="col ms-3 me-3">
              <div className="mb-3">
                <p className="text_st ">Investor Name</p>
                <span className="bolder_text ">
                  {data.investor_name === undefined || data.investor_name === ""
                    ? "-"
                    : data.investor_name}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Maximum Investment</p>
                <span className="bolder_text ">
                  {data?.kyc_forms && (!data?.kyc_forms[0]?.committed_principal ? "-" : "$ " + Number(data?.kyc_forms[0]?.committed_principal).toLocaleString())}
                </span>
              </div>
            </div>
            <div className="col ">
              <div className="mb-3">
                <p className="text_st ">Phone</p>
                <span className="bolder_text ">
                  {data.phone === undefined || data.phone === ""
                    ? "-"
                    : data.phone}
                </span>
              </div>
            </div>
            <div className="col-lg-2 ">
              <div className="mb-3">
                <p className="text_st ">Type</p>
                <span className="bolder_text ">
                  {data.type === undefined || data.type === ""
                    ? "-"
                    : data.type}
                </span>
              </div>
            </div>
            <hr />
            <div className="row d-flex justify-content-between mt-3">
              <div className="col invSubtextareafont">


                <p className="text_st mb-1">Comment<span style={{ color: "red" }}>*</span> </p>
                <Form>
                  <Form.Group
                    className=" "
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      size="lg"
                      className="ANLtextarea "
                      name="textarea"
                      as="textarea"
                      rows={2}
                      placeholder="Comment here."
                      onChange={handleInvestorNotes}
                    />
                  </Form.Group>
                </Form>

                <div className="mt-3">
                  <div className="upload_file_name ">
                    <div
                      className="container d-flex gap-5"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title={file}
                    >
                      <div>
                        {file != null
                          ? file.length > 25
                            ? file.slice(0, 25) + ".."
                            : file
                          : ""}
                      </div>
                      <div>
                        {file !== null && (
                          <a
                            style={{
                              display: "table-cell",
                              cursor: "pointer",
                            }}
                          >
                            <i
                              className="fa-solid fa-eye text-primary fa-eye-font mt-2"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Click to view image"
                              onClick={(e) => handleChangeDownload(e, file)}
                            />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>

                  {isUpload && (
                    <div className="loader">
                      <ThreeDots
                        height="30"
                        width="30"
                        radius="9"
                        color="#3D79F3"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3   ">
        <div className="">
          <button
            className="btn btn_background px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
        <div>
          <button
            className="btn mx-2 py-2 px-3"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            disabled={investorNotes == ''}
            variant="secondary"
            onClick={handleShowRejectInv}
          >
            Reject
          </button>
        </div>

        <div>
          <button
            className="btn blue_btn me-3 px-4 py-2"
            disabled={investorNotes == ''}
            onClick={approveIndivInvestorKYC}
          >
            Approve Individual KYC
          </button>
        </div>
      </Modal.Footer>
      <FillingFormModal
        data={data}
        show={fillingFormModal}
        onHide={() => setFillingFormModal(false)}
      />
      <FilledupViewModal
        momrefno={momRefNo}
        data={indivMomRefData}
        show={filledupViewModal}
        onHide={() => setFilledupViewModal(false)}
      />

      <Modal show={showInv} onHide={handleCloseRejectCloseInv}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="alert_modal">
          Are you sure you want to reject KYC?
        </Modal.Body>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectCloseInv}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={rejectInvestorKYC}
          >
            Yes
          </button>
        </div>
      </Modal>
    </Modal>
  );
};


export const ApprovedEyeDetailsModal = (props) => {
  let data = props.data;

  const handleClose = () => {
    props.onHide();
  };

  const handleDownload = async (doc) => {
    let url = doc.document_url;
    let file = doc.document_type;

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = data.business_name + "_" + doc.document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };
  const notifyToUpdateDocs = () => {
    axios
      .post(base_url + "documents-type/notify_renew_documents", {
        entity_id: data.business_id,
      })
      .then((res) => {
        handleClose();
        toast.success("Notification Sent", {
          toastId: 87,
        });
      });
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">{data?.type === INVESTOR_TYPE_INDIVIDUAL || data?.type === INVESTOR_TYPE_COMPANY ? "Investor Details" : "Business Details"}</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="px-4 py-2"
        style={{ height: "28rem", overflow: "auto" }}
      >

        <div className="container p-0 pb-3">
          <div className="row">

            {data?.type == INVESTOR_TYPE_COMPANY || data?.type == INVESTOR_TYPE_INDIVIDUAL ?
              <div>
                <div className="row">
                  <ModalFieldNoBorder label={"Investor Company Name"} value={data?.investor_company_name} />
                  <ModalFieldNoBorder label={"Investor Name"} value={data?.investor_name} />
                  <ModalFieldNoBorder label={"Country of Residence"} value={data?.country} />
                </div>
                <div className="row">
                  <ModalFieldNoBorder label={"Email"} value={data?.email} />
                  <ModalFieldNoBorder label={"Phone"} value={data?.phone} />
                  <ModalFieldNoBorder label={"Type"} value={data?.type} />
                </div>
                <div className="row">
                  <ModalFieldNoBorder label={"Nationality"} value={data?.nationality} />
                  <ModalFieldNoBorder label={"Source of Fund"} value={data?.sourse_of_fund} />
                  <ModalFieldNoBorder label={"Where did you hear about us?"} value={data?.hear_about_us} />
                </div>
                <div className="row">
                  <ModalFieldNoBorder label={"Maximum Investment"} value={
                    data?.kyc_forms?.[0]?.committed_principal !== undefined
                      ? `$${Number(data.kyc_forms[0].committed_principal).toLocaleString()}`
                      : "-"
                  }
                  />
                </div>
              </div>
              : <div>
                <div className="row">
                  <ModalFieldNoBorder label={"Business Name"} value={data?.business_name} />
                  <ModalFieldNoBorder label={"Contact Person"} value={data?.contact_person} />
                  <ModalFieldNoBorder label={"Phone"} value={data?.phone} />
                </div>
                <div className="row">
                  <ModalFieldNoBorder label={"Country of Business"} value={data?.country} />
                  <ModalFieldNoBorder label={"Business Type"} value={data?.business_type} />
                  <ModalFieldNoBorder label={"Year of Establishment"} value={data?.year_of_establishment} />
                </div>
                <div className="row">
                  <ModalFieldNoBorder label={"Turnover"} value={data?.turnover} />
                  <ModalFieldNoBorder label={"Where did you hear about us?"} value={data?.hear_about_us} />
                  <ModalFieldNoBorder label={"Email"} value={data?.email} />
                </div>
              </div>}

            <hr />

            <div className="row mt-2">
              <div className="col">
                <div className="row ">
                  <div className="col-lg-5">
                    {data.list_of_documents?.length === 0 ? (
                      <div className="fw-bold text-center mt-3">
                        No Documents
                      </div>
                    ) : (
                      <div className="pending_link_modal_docs_div">
                        {data.list_of_documents?.map((doc, index) => {
                          return (
                            <div className="row mb-3 gap-2 " key={index}>
                              <div
                                className="col-lg-8 fw-bold"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={doc.document_type}
                              >
                                {doc.document_type.length > 20
                                  ? doc.document_type.slice(0, 20) + ".."
                                  : doc.document_type}
                                <span className="comp_pending_expiry">
                                  {doc.expiry_date === null ||
                                    doc.expiry_date === undefined ? (
                                    "-"
                                  ) : moment().isSame(
                                    doc.expiry_date,
                                    "day"
                                  ) ? (
                                    <span className="comp_pending_today_expiry_txt">
                                      <p>Expiring</p> Today
                                    </span>
                                  ) : (
                                    <div className="d-flex gap-2">
                                      <p>Expiry Date</p>{" "}
                                      {moment(doc.expiry_date).format(
                                        "DD MMM YYYY"
                                      )}
                                    </div>
                                  )}
                                </span>
                              </div>
                              <div className="col">
                                <div className="d-flex gap-3">
                                  <div style={{
                                    pointerEvents: props.role_code === AUDITOR_ROLE ? 'none' : 'auto',
                                    opacity: props.role_code === AUDITOR_ROLE ? 0.5 : 1,
                                  }}>
                                    <a href={doc.document_url} target="_blank">
                                      <img src="./images/eye.svg" alt="" />
                                    </a>
                                  </div>
                                  <div
                                    className=" Cpointer"
                                    onClick={() => handleDownload(doc)}
                                    style={{ display: props.role_code === AUDITOR_ROLE ? 'none' : '' }}
                                  >
                                    <img src="./images/down.svg" alt="" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  <div className="col">
                    <p className="text_st mb-2">Notes</p>
                    <Form>
                      <Form.Group
                        className=" "
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Control
                          size="sm"
                          className="complaince_pendingLink_notes"
                          name="textarea"
                          as="textarea"
                          rows={2}
                          placeholder="Any notes if they want to save while they are uploading MOM can be noted down here."
                        />
                      </Form.Group>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex notift_btn_txtsize">
        <div>
          <button
            className="btn btn_background_sm mx-2  py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>

        <div>
          <button
            className="btn blue_btn me-3  py-2"
            onClick={notifyToUpdateDocs}
            disabled={props.role_code === AUDITOR_ROLE}
          >
            Notify To Update Expiring Documents
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export const QuarterlyCallReport = (props) => {
  let momReportsMaster = props.quarterlyMomReports;
  let quarterlyMomReports = props.quarterlyMomReports?.mom_reports;
  let data = props.data;
  let ltwo = props.ltwo;
  let role_code = props.role_code
  let loading = props.loading;
  let qcrNotes =
    momReportsMaster !== undefined ? momReportsMaster.qcr_notes : "";

  const [fillingFormModal, setFillingFormModal] = useState(false);
  const [filledupViewModal, setFilledupViewModal] = useState(false);
  const [quarterlyMomReptsFilter, setQuarterlyMomReptsFilter] = useState([]);

  const handleClose = () => {
    props.onHide();
  };


  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const titles = [
    { title: "MOM ID", sort: "mom_reference_no" },
    { title: "MOM Report", sort: "meeting_date" },
    { title: "View" },
  ];

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...quarterlyMomReports].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setQuarterlyMomReptsFilter(sortedData);
  };

  const [indivMomRefData, setIndivMomRefData] = useState([]);
  const [businessName, setBusinessName] = useState([]);

  const momRefNo = (doc, name) => {
    setBusinessName(name);
    setIndivMomRefData(doc);
  };
  const [saveNotesQReport, setSaveNotesQReport] = useState(qcrNotes);
  useEffect(() => {
    setSaveNotesQReport(qcrNotes);
  }, [qcrNotes]);

  const saveQReportData = () => {
    let user = Cookies.get("admin_user_name");
    let myObject = {
      business_id: data.business_id,
      admin_notes: saveNotesQReport,
      updated_by: user,
      admin_user_id: Cookies.get("admin_user_id"),
    };
    axios
      .post(base_url + "quarterly-call-reports/update_qcr_notes", myObject)
      .then((res) => {
        if (res.data.status == 200) {
          toast.success("Saved Successfully", {
            toastId: 99,
          });
          props.onHide();
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Quarterly Call Reports</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="px-4 py-2"
        style={{ height: "28rem", overflow: "auto" }}
      >
        <div className="container p-0 pb-3">
          <div className="row">
            <div className="col me-3">
              <div className="mb-3">
                <p className="text_st ">Business Name</p>
                <span className="bolder_text ">
                  {data.business_name === undefined ? "-" : data.business_name}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Status</p>
                <span className="bolder_text ">
                  {data.status === COMPLIANCE_PENDING
                    ? "Pending"
                    : data.status === COMPLIANCE_APPROVED
                      ? "Approved"
                      : data.status === COMPLIANCE_REJECTED
                        ? "Rejected"
                        : "-"}
                </span>
              </div>
            </div>
            <div className="col ">
              <div className="mb-3">
                <p className="text_st ">Contact Person</p>
                <span className="bolder_text ">
                  {data.user_name === undefined || data.user_name === ""
                    ? "-"
                    : data.user_name}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Current Turnover</p>
                <span className="bolder_text ">
                  {data.turnover === undefined || data.turnover === ""
                    ? "-"
                    : data.turnover}
                </span>
              </div>
            </div>
            <div className="col ">
              <div className="mb-3">
                <p className="text_st ">Phone</p>
                <span className="bolder_text ">
                  {data.phone === undefined || data.phone === ""
                    ? "-"
                    : data.phone}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Country</p>
                <span className="bolder_text ">
                  {data.country === undefined || data.country === ""
                    ? "-"
                    : data.country}
                </span>
              </div>
            </div>
            <div className="col ">
              <div className="mb-3">
                <p className="text_st ">Type</p>
                <span className="bolder_text ">
                  {data.type === undefined || data.type === ""
                    ? "-"
                    : data.type}
                </span>
              </div>
            </div>

            <div className="">
              <p className="text_st mb-1">Notes</p>
              <Form>
                <Form.Group
                  className=" text_area_placeholder"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    size="sm"
                    className="ANLtextarea "
                    name="textarea_qcrNotes"
                    as="textarea"
                    rows={2}
                    value={saveNotesQReport}
                    onChange={(e) => setSaveNotesQReport(e.target.value)}
                  />
                </Form.Group>
              </Form>
            </div>
            <hr />

            <div className="row d-flex justify-content-between">
              <div className="col-lg-7">
                {quarterlyMomReports?.length === 0 ||
                  quarterlyMomReports?.length === undefined ? (
                  <div className="text-center fw-bold">
                    No quarterly call reports are uploaded yet
                  </div>
                ) : (
                  <div>
                    <div>
                      <h6 className="mb-2">
                        Quarterly call reports submitted by admin team
                      </h6>
                    </div>
                    <div className="all_inv_newinv_table_mod">
                      <Table striped className="  ">
                        <thead className="Q_call_report_headers">
                          <tr>
                            {titles.map((data, id) => (
                              <th
                                key={data.sort}
                                onClick={() => handleSort(data.sort)}
                              >
                                {data.title}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {quarterlyMomReports?.map((doc) => {
                            return (
                              <tr key={doc.mom_report_id}>
                                <td>
                                  {ltwo || loading ? (
                                    <Skeleton width={100} height={15} />
                                  ) : (
                                    doc.mom_reference_no
                                  )}
                                </td>

                                <td>
                                  {moment(doc.meeting_date).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                                <td>
                                  <div className="ms-2 Cpointer">
                                    <img
                                      src="./images/eye.svg"
                                      alt=""
                                      className=""
                                      onClick={() =>
                                        setFilledupViewModal(
                                          true,
                                          momRefNo(doc, data.business_name)
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-lg-4">
                <div
                  className="upload_report_btn "
                  // onClick={() => setFillingFormModal(true)}
                  onClick={() => {
                    if (role_code !== AUDITOR_ROLE) {
                      setFillingFormModal(true);
                    }
                  }}
                >
                  <label className="Cpointer ">
                    <span className="">
                      <img src="./images/upload.svg" alt="" /> Upload Quarterly
                      Call Report
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3   ">
        <div className="">
          <button
            className="btn btn_background px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
        <div>
          <button
            className="btn blue_btn me-3 px-4 py-2"
            onClick={saveQReportData}
            disabled={props.role_code}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
      <FillingFormModal
        data={data}
        show={fillingFormModal}
        onHide={() => setFillingFormModal(false)}
      />
      <FilledupViewModal
        momrefno={momRefNo}
        data={indivMomRefData}
        bname={businessName}
        show={filledupViewModal}
        onHide={() => setFilledupViewModal(false)}
      />
    </Modal>
  );
};

export const FilledupViewModal = (props) => {
  let data = props.data;

  const handleClose = () => {
    props.onHide();
    setFlag(false);
  };

  const divRef = useRef(null);

  const [flag, setFlag] = useState(false);

  const downloadPdf = () => {
    setFlag(true);
    setTimeout(() => {
      html2canvas(divRef.current).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 0, 0);
        pdf.save(`${props.bname}` + "_" + "MOM_Report_Info.pdf");

        handleClose();
      });
    }, 500);
  };

  const handleDownloadfilledupViewmodal = async (doc) => {
    let url = doc.document_url;
    let file = doc.document_type;
    let etype = doc.entity_type;

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = etype + "_" + file;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="xl"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">MOM Report Info</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ height: "28rem", overflow: "auto" }}>
        <div ref={divRef} className="px-4 pt-4">
          {flag && (
            <img
              className="pdfLogo"
              src="./images/blue_brand_name.svg"
              alt=""
            />
          )}
          <div className="container p-0 pb-1">
            <div className="row">
              <div className="col ">
                <div className="mb-3">
                  <p className="text_st ">Date</p>
                  <span className="bolder_text ">
                    {moment(data.meeting_date).format("DD MMM YYYY")}
                  </span>
                </div>
              </div>
              <div className="col">
                <div className="mb-3">
                  <p className="text_st ">Name Of the Company</p>
                  <span className="bolder_text ">
                    {props.bname === "" || props.bname === undefined
                      ? "-"
                      : props.bname}
                  </span>
                </div>
              </div>
              <div className="col">
                <div className="mb-3">
                  <p className="text_st ">Who was met</p>
                  <span className="bolder_text ">
                    {data.name_of_person_met}
                  </span>
                </div>
              </div>
              <div className="col">
                <div className="mb-3">
                  <p className="text_st ">Who Visited</p>
                  <span className="bolder_text ">
                    {data.name_of_person_visited}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="container d-flex flex-column gap-2 ps-0 momreport_details_popup">
            <div>
              <p>Subject of the Meeting</p>
              <span>
                {data.subject_of_meeting === "" ||
                  data.subject_of_meeting === undefined
                  ? "-"
                  : data.subject_of_meeting}
              </span>
            </div>
            <div>
              <p>Current Financial Status of the Company</p>
              <span>
                {data.current_financial_status === "" ||
                  data.current_financial_status === undefined
                  ? "-"
                  : data.current_financial_status}
              </span>
            </div>
            <div>
              <p>Current Status of the Promoter of the Company</p>
              <span>
                {data.current_status_of_promoter === "" ||
                  data.current_status_of_promoter === undefined
                  ? "-"
                  : data.current_status_of_promoter}
              </span>
            </div>
            <div>
              <p>Any Red Flags</p>
              <span>
                {data.red_flag === "" || data.red_flag === undefined
                  ? "-"
                  : data.red_flag}
              </span>
            </div>
            <div>
              <p>Any New Requests</p>
              <span>
                {data.new_requests === "" || data.new_requests === undefined
                  ? "-"
                  : data.new_requests}
              </span>
            </div>
          </div>
        </div>
        <hr />
        <div className="ps-4">
          {data.documents?.map((doc, index) => {
            return (
              <div className="row momreport_filledupview_doc_styl" key={index}>
                <div
                  className="col-lg-3 fw-bold"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title={doc.document_type}
                >
                  {doc.document_type?.length > 20
                    ? doc.document_type.slice(0, 20) + ".."
                    : doc.document_type}
                </div>
                <div className="col">
                  {doc.document_type !== "" ? (
                    <div className="d-flex gap-3">
                      <div>
                        <a href={doc.document_url} target="_blank">
                          <img src="./images/eye.svg" alt="" />
                        </a>
                      </div>
                      <div
                        className=" Cpointer"
                        onClick={() => handleDownloadfilledupViewmodal(doc)}
                      >
                        <img src="./images/down.svg" alt="" />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3 ">
        <div>
          <button
            className="btn blue_btn me-3 px-4 py-2 "
            onClick={downloadPdf}
          >
            Download as PDF
          </button>
          <button
            className="btn btn_background mx-2 px-3 "
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export const PendingLinkModal = (props) => {


  let data = props.data;
  let businessname = props?.bname;
  let singleBsnsData = props?.singleBsnsData;
  let getDocuments = props?.data?.kyc_documents;
  let riskDataValue = props.riskAssessmentCompleted;

  const navigate = useNavigate();

  const titles = ["Type", "Actions"]
  const fileInputRef = useRef(null);
  const [others, setOthers] = useState([]);
  const [profileLogo, setProfileLogo] = useState("");
  const handleClose = () => {
    props.onHide();
  };
  const [pendingLinkNotes, setPendingLinkNotes] = useState("");
  const handleChangeInputNotes = (e) => {
    let value = e.target.value;
    if (!value) {
      setPendingLinkNotes("");
      setApproveKYCBtn(true)
    } else {
      setPendingLinkNotes(e.target.value);
      setApproveKYCBtn(false)
    }
  };

  let processing_fee_options = [
    { type: "Yes", id: 1 },
    { type: "No", id: 2 },
  ];

  const [radio_Value, setRadio_Value] = useState("");


  const [businessuserName, setBusinessuserName] = useState("");
  const handleChangeInputusername = (e) => {
    setBusinessuserName(e.target.value);
  };
  const [approveKYCBtn, setApproveKYCBtn] = useState(true)
  const approveKYC = () => {
    setApproveKYCBtn(true)

    if (data.type == INVESTOR_TYPE_COMPANY || data.type == INVESTOR_TYPE_INDIVIDUAL) {
      let myObject = {
        investor_id: data.investor_id,
        investor_kyc_id: data.investor_kyc_id,
        admin_user_id: Cookies.get("admin_user_id"),
        admin_notes: pendingLinkNotes,
        validated_by: Cookies.get("admin_user_name"),
      };
      const fData = new FormData();
      if (invurl != null) {
        const fileName = profileLogo;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fData.append('profile_logo', investorLogoNAme);
        fData.append('file', invurl, fileExtension);
      }
      if (busurl != null) {
        const fileName = profileLogo;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fData.append('profile_logo', businessLogoNAme);
        fData.append('file', busurl, fileExtension);
      }
      if (others.length !== 0) {
        others.filter((doc) => doc && doc.name).forEach((doc) => {
          const fileName = doc?.name;
          if (fileName) {
            fData.append('file_name', fileName);
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);

            fData.append('file', doc, "Others" + "." + fileExtension);
          }
        });

      }
      for (let key in myObject) {
        if (myObject.hasOwnProperty(key)) {
          fData.append(key, myObject[key]);
        }
      }
      axios
        .post(base_url + "investor-master/approve_investor_kyc", fData)
        .then((res) => {
          if (res.data.status == 200) {
            toast.success("KYC Approved Successfully", {
              toastId: 4,
            });
            props.onHide();
            setApproveKYCBtn(false)
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        });
    } else {
      let myObject = {
        business_id: data.business_id,
        business_kyc_id: data.business_kyc_id,
        admin_user_id: Cookies.get("admin_user_id"),
        admin_notes: pendingLinkNotes,
        transaction_alignment: radio_Value === "Yes" ? 1 : 0,
        validated_by: Cookies.get("admin_user_name"),
        user_name: businessuserName
      };
      const fData = new FormData();
      if (busurl != null) {
        const fileName = profileLogo;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fData.append('profile_logo', businessLogoNAme);
        fData.append('file', busurl, fileExtension);
      }
      if (others.length !== 0) {
        others.filter((doc) => doc && doc.name).forEach((doc) => {
          const fileName = doc?.name;
          if (fileName) {
            fData.append('file_name', fileName);
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);

            fData.append('file', doc, "Others" + "." + fileExtension);
          }
        });

      }
      for (let key in myObject) {
        if (myObject.hasOwnProperty(key)) {
          fData.append(key, myObject[key]);
        }
      }
      axios
        .post(base_url + "business-master/approve_kyc_form", fData)
        .then((res) => {
          if (res.data.status == 200) {
            toast.success("KYC Approved Successfully", {
              toastId: 4,
            });
            props.onHide();
            setApproveKYCBtn(false)
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        });
    }

  };
  const [show, setShow] = useState(false);

  const handleShowReject = () => setShow(true);
  const handleCloseRejectClose = () => {
    setShow(false);
  };

  const handleCloseReject = () => {
    //hit the api from rejection api here

    if (data.type == INVESTOR_TYPE_COMPANY || data.type == INVESTOR_TYPE_INDIVIDUAL) {

      let myObject = {
        investor_id: singleBsnsData.investor_id,
        investor_kyc_id: singleBsnsData.investor_kyc_id,
        admin_notes: pendingLinkNotes,
        validated_by: Cookies.get("admin_user_name"),
        admin_user_id: Cookies.get("admin_user_id"),
      };

      axios
        .post(base_url + "investor-master/reject_investor_kyc", myObject)
        .then((res) => {
          if (res.data.status == 200) {
            props.onHide();
            toast.success("Rejected Successfully", {
              toastId: 4,
            });
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        });
    }
    else {

      let myObject = {
        business_id: singleBsnsData.business_id,
        business_kyc_id: singleBsnsData.business_kyc_id,
        admin_notes: pendingLinkNotes,
        validated_by: Cookies.get("admin_user_name"),
        admin_user_id: Cookies.get("admin_user_id"),
      };

      axios
        .post(base_url + "business-master/reject_kyc_form", myObject)
        .then((res) => {
          if (res.data.status == 200) {
            props.onHide();
            toast.success("Rejected Successfully", {
              toastId: 4,
            });
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        });

    }
  };
  const [fileArray, setFileArray] = useState([]);
  const handleChange = (event) => {
    const maxFileSize = 5242880;
    const files = Array.from(event.target.files);
    const updatedFiles = [...fileArray, ...files];
    setFileArray(updatedFiles);
    if (updatedFiles.length < 51) {
      const validFiles = files.filter((file) => file.size < maxFileSize);
      const invalidFiles = files.filter((file) => file.size >= maxFileSize);
      if (invalidFiles.length > 0) {
        toast.error("Some files exceed 5MB and were not uploaded.", {
          toastId: 7,
        });
      }
      validFiles.forEach((file) => {
        setOthers((prevItems) => [...prevItems, file]);
      });
    } else {
      toast.warn("Max limit of 50 files reached!");
    }
  };
  const [busurl, setUploadedBusUrl] = useState(null);
  const [invurl, setUploadedInvUrl] = useState(null);
  const [id, setId] = useState();
  const [businessLogoNAme, setBusinessLogoNAme] = useState("");
  const [investorLogoNAme, setInvestorLogoNAme] = useState("");
  const handleChangeProfileLogo = (e) => {
    const fileName = e.target.files[0].name;
    const lastDotIndex = fileName.lastIndexOf('.');
    const fileExtension = fileName.substring(lastDotIndex + 1);
    if (fileExtension == "png" || fileExtension == "jpeg" || fileExtension == "jpg" || fileExtension == "svg") {
      setProfileLogo(URL.createObjectURL(e.target.files[0]));
      if (e.target.id === "business-input") {
        setId("business-input");
        const url = URL.createObjectURL(e.target.files[0]);
        setBusinessLogoNAme(e.target.files[0].name);
        setUploadedBusUrl(e.target.files[0]);
      }
      else {
        setId("investor-input");
        const url = URL.createObjectURL(e.target.files[0]);
        setInvestorLogoNAme(e.target.files[0].name);
        setUploadedInvUrl(e.target.files[0]);
      }
    }
    else {
      toast.error("Please upload a profile in either JPG, JPEG, SVG or PNG format.", { toastId: 98 })
    }
  }
  const handleChangeProfileDownload = () => {
    if (id === "business-input") {
      if (busurl instanceof File) {
        const fileURL = URL.createObjectURL(busurl);
        window.open(fileURL, '_blank');
      }
    }
    else {
      const fileURL = URL.createObjectURL(invurl);
      window.open(fileURL, "_blank");
    }
  }

  const handleDeleteClick = () => {
    setProfileLogo("");
  }

  const handleChangeDownloadForOthers = (event, file, doc) => {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
    }
    else {
      if (file.document_url && typeof file.document_url === 'string') {
        window.open(file.document_url, '_blank');
      }
    }
  }

  const handleDeleteClickOthers = (item) => {
    let updatedOthers;
    if (item instanceof File) {
      updatedOthers = others.filter((doc) => doc.name !== item.name);
    } else {
      updatedOthers = others.filter((doc) => doc.document_type !== item.document_type);
    }
    setOthers(updatedOthers);
  };
  const handleDownload = async (doc) => {

    let url = doc.document_url;
    let file = doc.document_type;

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = businessname + "_" + doc.document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };

  const [roleCode, setRoleeCode] = useState(() => {
    const storedRoleeCode = Cookies.get('role_code');
    return storedRoleeCode ? storedRoleeCode : '';
  });

  useEffect(() => {
    if (roleCode) {
      try {
        const decryptedValueData = decrypt(roleCode);
        setRoleeCode(decryptedValueData);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  }, [])

  // const isRiskPendingForIndividual =
  //   data?.type === INVESTOR_TYPE_INDIVIDUAL &&
  //   !data?.kyc_forms?.[0]?.risk_assessment_completed;

  const isRiskPendingForIndividual =
    data?.type === INVESTOR_TYPE_INDIVIDUAL &&
    !riskDataValue;




  const formatDOB = (dob) => {
    if (!dob) return "";
    // Case 1: Proper date format (YYYY-MM-DD)
    if (moment(dob, "YYYY-MM-DD", true).isValid()) {
      return moment(dob).format("DD-MMM-YYYY");
    }

    // Case 2: Numeric timestamp (like 888844563)
    if (!isNaN(dob)) {
      return moment(Number(dob)).format("DD-MMM-YYYY");
    }

    if (moment(dob, "DD-MM-YYYY", true).isValid()) {
      return moment(dob).format("DD-MMM-YYYY");
    }



    return "";
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="xl"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">{data?.type === INVESTOR_TYPE_INDIVIDUAL || data?.type === INVESTOR_TYPE_COMPANY ? "Investor Details" : "Business Details"}</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      {data?.type === INVESTOR_TYPE_INDIVIDUAL ?
        <Modal.Body
          className="px-4 py-2"
          style={{ height: "28rem", overflow: "auto" }}
        >

          <div className="container p-0 pb-3">
            <div className="">
              <div class="row gap-3">
                <ModalField label={"Name of the Investor"} value={businessname} />
                <ModalField label={"Phone"} value={data.phone} />
                <ModalField label={"Type"} value={data.type} />


              </div>
              <div className="row gap-3">

                <ModalField label={"Gender "} value={data.gender} />
                <ModalField label={"Country of Residence "} value={data.country} />
                <ModalField label={"Nationality"} value={data.nationality} />
              </div>
              <div className="row">
                <TextAreaField textareaClassName={"bolder_text_textarea"} className={"mb-3 "} disabled={true} label={"Address (as per address proof)"} value={data?.registered_address || '-'} />

              </div>

              <div class="row gap-3">
                <ModalField label={"Home Country Contact"} value={data?.home_country_contact} />
                <ModalField label={"Country of Birth"} value={data.country_of_birth} />
                <ModalField label={"Date of birth"}
                  value={singleBsnsData?.date_of_birth ? formatDOB(singleBsnsData?.date_of_birth) : ""} />

              </div>

              <div class="row gap-3">
                <ModalField label={"Passport Number"} value={data.passport_number} />
                <ModalField label={"Passport Expiry Date"} value={data.passport_expiry_date ? moment(data.passport_expiry_date).format("DD-MMM-YYYY") : ""} />
                <ModalField label={"Other Passport Details"} value={data.other_passport_details} />

              </div>
              <div class="row gap-3">
                <ModalField label={"National ID Number"} value={data.national_id} />
                <ModalField label={"Name of Employer or Business owned"} value={data.name_of_employer} />
                <ModalField label={"Country of Business or Employer"} value={data.country_of_employer} />

              </div>
              <div class="row gap-3">
                <div className="col-lg-8">
                  <ModalField label={"Source of income"} value={data?.sourse_of_fund} />
                </div>
                <div className="col">
                  <ModalField label={"Committed Principal"} value={data?.committed_principal} />
                </div>

              </div>

              {/* <div class="row gap-2 mt-3">
                <h6 className="text-primary fw-bolder">Purpose of and Nature of the Business:</h6>
                <TextAreaField textareaClassName={"bolder_text_textarea"} disabled={true} label={"Brief description of activity providing source of income"} value={data.description_of_income} />

              </div> */}

              <div class="row gap-2 mt-3">
                {/* <h6 className="text-primary fw-bolder">Commercial Information:</h6> */}
                <h6 className="text-primary fw-bolder">Nominee Details:</h6>
              </div>
              {/* <TextAreaField textareaClassName={"bolder_text_textarea"} className={"mb-3"} disabled={true} label={"Nominee Details"} value={data.nominee_details} /> */}
              <div className="row gap-3">
                <ModalField label={"Nominee Name"} value={data.nominee_name} />
                <ModalField label={"Nominee Date of Birth"} value={data?.nominee_dob ? moment(data?.nominee_dob).format("DD-MMM-YYYY") : ""} />

              </div>
              <div className="row gap-3">
                <ModalField label={"Contact Number"} value={data.nominee_contact} />
                <ModalField label={"Relationship"} value={data.nominee_relationship} />
              </div>
              <div class="row gap-2 mt-3">
                <h6 className="text-primary fw-bolder">  Guardian Details:</h6>
              </div>
              <div className="row gap-3">
                <ModalField label={"Guardian Name"} value={data.guardian_name} />
                <ModalField label={"Guardian Date of Birth"} value={data?.guardian_dob ? moment(data?.guardian_dob).format("DD-MMM-YYYY") : ""} />

              </div>
              <div className="row gap-3">
                <TextAreaField textareaClassName={"bolder_text_textarea"} disabled={true} label={"Guardian Address"} value={data.guardian_address || '-'} />

              </div>


              <div className="row ">

                <div className="col mt-2 mb-3">
                  <label htmlFor="topCustomers " style={{ fontSize: "16px" }}>
                    <p>Are you a politically exposed person(PEP) :</p>
                  </label>
                </div>

                <div className="col-lg-8 is_pep_div">
                  {singleBsnsData?.is_pep}
                </div>
              </div>
              <div className="row">

                {getDocuments?.length > 0 ?
                  <div>
                    <p className="text_st mb-1">KYC Documents</p>
                    <Table striped className="border my_loan_table w-75" >
                      <thead>
                        <tr>
                          {titles.map((title, id) => (
                            <th key={id} >{title}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {getDocuments?.map((doc, index) => {
                          return (
                            <tr key={index}>
                              <td >{doc.document_type == undefined ? '-' : doc.document_type}</td>
                              <td >
                                <div className="d-flex justify-content-evenly">
                                  <div className='align-self-center' style={{ pointerEvents: 'auto', opacity: 1 }} >
                                    <a style={{ display: "table-cell" }} href={doc.document_url} target="_blank">
                                      <img src="./images/eye.svg" alt="" /></a>
                                  </div>
                                  <div className=' ps-3 Cpointer' onClick={() => handleDownload(doc)} style={{ display: roleCode === AUDITOR_ROLE ? 'none' : '' }}><img src="./images/down.svg" alt="" /></div>
                                </div>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </div> : <NoDocs />}

              

                {(data?.status === COMPLIANCE_PENDING || data?.status === COMPLIANCE_APPROVED) && (
                  <div className="d-flex align-items-center gap-3 mt-3 mb-3">
                    <button
                      type="button"
                      className="ekyc-btn"
                      onClick={() => navigate(`/ekyc/details/view/${data?.investor_id}/${data?.investor_kyc_id}?status=${data?.status}`, {
                        state: {
                          reopenModal: true,
                          pendingLinkData: props.data,
                          singleBsnsData: props.singleBsnsData,
                          getDocuments: props.getDocuments,
                          bname: props.bname,
                          investor_kyc_id: data?.investor_kyc_id,
                          investor_id: data?.investor_id,
                          riskAssessmentCompleted: props?.riskAssessmentCompleted,
                        }
                      })
                      }
                    >
                      eKYC
                    </button>




                    <span className="ekyc-status-badge">
                      {riskDataValue ? "Completed" : "Pending"}
                    </span>


                  </div>
                )}
              </div>




              {(data?.status === COMPLIANCE_PENDING || data?.status === COMPLIANCE_APPROVED) && riskDataValue && (
                <div className="risk-info-box">
                  ✔ Risk Assessment is Completed.
                </div>
              )}




              {data?.status === COMPLIANCE_PENDING && <div>
                <div>
                  <div className="col-lg-2">
                    <label className="d-flex align-items-center">
                      <img
                        src="./images/icons/plus_symbol.svg"
                        alt="UploadFile"
                        className="plus-icon"
                      />
                      <span className="me-3 text-start upload-text">
                        {" "}
                        {others.length == 0 ? "Upload Files" : " Uploaded"}
                      </span>
                      <input
                        ref={fileInputRef}
                        className="custom-file-input"
                        type="file"
                        multiple
                        onChange={(e) => handleChange(e)}
                        style={{ display: "none" }}
                      />
                    </label>
                  </div>

                  {others.length > 0 && (
                    <div className="col-lg-5 ">
                      <div style={{ height: "100px", overflowY: "auto" }}>
                        {others.map((doc) => (
                          <span>
                            <a
                              style={{ cursor: "pointer" }}
                            >
                              <FaEye className="eye-color mt-1" data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Click to view image"
                                onClick={(e) => handleChangeDownloadForOthers(e, doc, doc.name)}
                              />
                            </a>{" "}
                            <span className="input_filname"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={doc instanceof File ? doc.name : doc.document_type}
                              style={{
                                display: "inline-block",
                                maxWidth: "300px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {" "}
                              {doc.name ? (doc.name.length > 50 ? doc.name.slice(0, 50) + "..." : doc.name) : doc.document_type}
                            </span>
                            <span
                              onClick={() => handleDeleteClickOthers(doc)}
                            >
                              <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{ marginLeft: "10px" }} />
                            </span>
                            <br />
                          </span>
                        ))}
                      </div>
                    </div>)}


                  <div className="">
                    <label className="d-flex align-items-center">
                      <img
                        src="./images/icons/plus_symbol.svg"
                        alt="UploadFile"
                        className="plus-icon"
                      />
                      <span className="me-3 text-start upload-text">
                        {" "}
                        {profileLogo === "" ? "Upload Logo" : " Uploaded"}
                      </span>
                      <input
                        ref={fileInputRef}
                        className="custom-file-input"
                        type="file"
                        onChange={(e) => handleChangeProfileLogo(e)}
                        style={{ display: "none" }}
                        accept="image/*"
                        id="investor-input"
                      />
                    </label>
                    {profileLogo &&
                      <span>
                        <a
                          style={{ cursor: "pointer" }}
                        >
                          <FaEye className="eye-color mt-1" data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Click to view image"
                            onClick={(e) => handleChangeProfileDownload()}
                          />
                        </a>{" "}
                        <span className="input_filname"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={investorLogoNAme}
                          style={{
                            display: "inline-block",
                            maxWidth: "300px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {" "}
                          {investorLogoNAme.length > 50 ? investorLogoNAme.slice(0, 50) + "..." : investorLogoNAme}
                        </span>
                        <span
                          onClick={() => handleDeleteClick()}
                        >
                          <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{ marginLeft: "10px" }} />
                        </span>
                        <br />
                      </span>
                    }
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col">

                    <p className="text_st mb-2">Comment<span className="text-danger">*</span></p>
                    <Form>
                      <Form.Group
                        className=" "
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Control
                          size="sm"
                          className="complaince_pendingLink_notes"
                          name="textarea"
                          as="textarea"
                          rows={2}
                          placeholder="Please type comment here."
                          onChange={handleChangeInputNotes}
                        />
                      </Form.Group>
                    </Form>

                  </div>
                </div>
              </div>}
            </div>
          </div>

        </Modal.Body> :
        <Modal.Body
          className="px-4 py-2"
          style={{ height: "28rem", overflow: "auto" }}
        >

          <div className="container p-0 pb-3">
            <div className="">
              <div class="row gap-3">
                <ModalField label={"Business Name"} value={businessname} />
                <ModalField label={"Type"} value={data?.type === INVESTOR_TYPE_COMPANY ? data.investor_company_type : data.business_type} />
                <ModalField label={"Phone"} value={data.phone} />
              </div>
              <div class="row gap-3">

                <ModalField label={"Country of Business"} value={data?.country} />

                <ModalField label={"Sector"} value={data.sector} />
                <ModalField label={"KYC Expiry Date"} value={moment(singleBsnsData?.kyc_expiry_date).format("DD-MMM-YYYY")} />

              </div>
              <div className="row">
                <ModalField label={"Address"} value={data?.registered_address} />

              </div>
              <div class="row gap-3">
                <ModalField label={"Place of Incorporation/Establishment"} value={data.place_of_incorporation} />
                <ModalField label={"Date of Incorporation"} value={data.date_of_incorporation ? moment(data.date_of_incorporation).format("DD-MMM-YYYY") : ""} />

              </div>
              <div class="row gap-3">
                <ModalField label={"Trade License No"} value={data?.trade_license_no} />
                <ModalField label={"Trade License Expiry Date"} value={moment(singleBsnsData?.trade_license_expiry_date).format("DD-MMM-YYYY")} />

              </div>
              <div className="row">
                <ModalField label={"Description Of Business"} value={data?.description_of_business} />
              </div>
              <div class="row gap-3">
                <ModalField label={"Import Countries With Percentage"} value={data.import_countries_with_percentage} />
                <ModalField label={"Export Countries With Percentage"} value={data.export_countries_with_percentage} />
                <ModalField label={"Re-export Countries With Percentage"} value={data.re_export_countries_with_percentage} />

              </div>
              <div class="row gap-3">
                <ModalField label={"Origin of Products"} value={data.origin_of_products} />
                <ModalField label={"Products by the Company"} value={data.products_by_the_company} />

                {/* <ModalField label={"Created Date"} value={ moment(singleBsnsData?.created_date_time).format("DD-MMM-YYYY")}/> */}
              </div>
              <div class="row gap-3">
                <ModalField label={"Beneficial Owner With Percentage Holding"} value={data.beneficial_owner_with_percentage_holding} />
              </div>
              <div class="row gap-3">

              </div>
              <div class="row gap-3">

              </div>




              {singleBsnsData?.shareholders?.length > 0 && <div className="row">
                <div className="mb-3 col me-3">
                  <p className="text_st mb-1">Share Holders</p>

                  <div className="d-flex gap-3 ">
                    <Table className="kyc_table" bordered>
                      <thead >
                        <th>Name</th>
                        <th>DOB</th>
                        <th>Nationality</th>
                        <th>Country of Residence</th>
                        <th>Designation</th>
                      </thead>
                      <tbody>
                        {singleBsnsData?.shareholders?.map(i => {
                          return (
                            <tr>
                              <td className="">
                                {i.name_of_shareholder}   </td>
                              <td>{i.dob_of_shareholder ? moment(i.dob_of_shareholder).format("DD-MMM-YYYY") : ""}</td>
                              <td>{i.nationality_of_shareholder}</td>
                              <td>{i.residential_country_of_shareholder}</td>
                              <td>{i.designation_of_shareholder}</td>

                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>}

              {singleBsnsData?.type == INVESTOR_TYPE_COMPANY || singleBsnsData?.type == INVESTOR_TYPE_INDIVIDUAL ? "" :
                <div className="row ">

                  <div className="col mt-2">
                    <label htmlFor="topCustomers" style={{ fontSize: "16px" }}>
                      <p className="text_st mb-1">List of banks dealt with by the company :</p>
                    </label>
                  </div>

                  <div className="col-lg-8 mb-4 ">{singleBsnsData?.banks_list?.map((i, index) => {
                    return (
                      <div className="mb-2 shareholder_tab" key={index}>
                        <input
                          // disabled={rejectedFlag}
                          type="text"
                          name={`customer${index}`}
                          id={`customer${index}`}
                          className="form-control bg-white"
                          placeholder={`Customer ${index + 1}`}
                          value={i}

                        />
                      </div>
                    );
                  })}

                  </div>
                </div>}






              <div className="row ">

                <div className="col mt-2">
                  <label htmlFor="topCustomers" style={{ fontSize: "16px" }}>
                    <p>List top 5 customers (buyers) of the company :</p>
                  </label>
                </div>

                <div className="col-lg-8 mb-4">{singleBsnsData?.top_5_customers?.map((i, index) => {
                  return (
                    <div className="mb-2 shareholder_tab" key={index}>
                      <input
                        // disabled={rejectedFlag}
                        type="text"
                        name={`customer${index}`}
                        id={`customer${index}`}
                        className="form-control bg-white"
                        placeholder={`Customer ${index + 1}`}
                        value={i}

                      />
                    </div>
                  );
                })}

                </div>
              </div>





              <div className="row ">

                <div className="col mt-2 mb-3">
                  <label htmlFor="topCustomers " style={{ fontSize: "16px" }}>
                    <p>List of top 5 suppliers of the company :</p>
                  </label>
                </div>

                <div className="col-lg-8 mb-4">
                  {
                    singleBsnsData?.top_5_suppliers?.map((i, index) => (
                      <div className="mb-2 shareholder_tab" key={index}>
                        <input
                          type="text"
                          className="form-control bg-white"
                          value={
                            i
                          }

                        />
                      </div>
                    ))}
                </div>
              </div>
              <div className="row ">

                <div className="col mt-2 mb-3">
                  <label htmlFor="topCustomers " style={{ fontSize: "16px" }}>
                    <p>Are you a politically exposed person(PEP) :</p>
                  </label>
                </div>

                <div className="col-lg-8 is_pep_div">
                  {singleBsnsData?.is_pep}
                </div>
              </div>





              <div className="row">

                {getDocuments?.length > 0 ?
                  <div>
                    <p className="text_st mb-1">KYC Documents</p>
                    <Table striped className="border my_loan_table w-75" >
                      <thead>
                        <tr>
                          {titles.map((title, id) => (
                            <th key={id} >{title}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {getDocuments?.map((doc, index) => {
                          return (
                            <tr key={index}>
                              <td >{doc.document_type == undefined ? '-' : doc.document_type}</td>
                              <td >
                                <div className="d-flex justify-content-evenly">
                                  <div className='align-self-center' style={{
                                    pointerEvents: 'auto',
                                    opacity: 1,
                                  }} >
                                    <a style={{ display: "table-cell" }} href={doc.document_url} target="_blank">
                                      <img src="./images/eye.svg" alt="" /></a>
                                  </div>
                                  <div className=' ps-3 Cpointer' onClick={() => handleDownload(doc)} style={{ display: roleCode === AUDITOR_ROLE ? 'none' : '' }}><img src="./images/down.svg" alt="" /></div>
                                </div>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </div> : <NoDocs />}
              </div>



              {data?.status === COMPLIANCE_PENDING && <div>
                <div>
                  <div className="col-lg-2">
                    <label className="d-flex align-items-center">
                      <img
                        src="./images/icons/plus_symbol.svg"
                        alt="UploadFile"
                        className="plus-icon"
                      />
                      <span className="me-3 text-start upload-text">
                        {" "}
                        {others.length == 0 ? "Upload Files" : " Uploaded"}
                      </span>
                      <input
                        ref={fileInputRef}
                        className="custom-file-input"
                        type="file"
                        multiple
                        onChange={(e) => handleChange(e)}
                        style={{ display: "none" }}
                      />
                    </label>
                  </div>
                  {others.length > 0 && (
                    <div className="col-lg-5 ">
                      <div style={{ height: "100px", overflowY: "auto" }}>
                        {others.map((doc) => (
                          <span>
                            <a
                              style={{ cursor: "pointer" }}
                            >
                              <FaEye className="eye-color mt-1" data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Click to view image"
                                onClick={(e) => handleChangeDownloadForOthers(e, doc, doc.name)}
                              />
                            </a>{" "}
                            <span className="input_filname"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={doc instanceof File ? doc.name : doc.document_type}
                              style={{
                                display: "inline-block",
                                maxWidth: "300px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {" "}
                              {doc.name ? (doc.name.length > 50 ? doc.name.slice(0, 50) + "..." : doc.name) : doc.document_type}
                            </span>
                            <span
                              onClick={() => handleDeleteClickOthers(doc)}
                            >
                              <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{ marginLeft: "10px" }} />
                            </span>
                            <br />
                          </span>
                        ))}
                      </div>
                    </div>)}
                  <div className="">
                    <label className="d-flex align-items-center">
                      <img
                        src="./images/icons/plus_symbol.svg"
                        alt="UploadFile"
                        className="plus-icon"
                      />
                      <span className="me-3 text-start upload-text">
                        {" "}
                        {profileLogo === "" ? "Upload Logo" : " Uploaded"}
                      </span>
                      <input
                        ref={fileInputRef}
                        className="custom-file-input"
                        type="file"
                        onChange={(e) => handleChangeProfileLogo(e)}
                        style={{ display: "none" }}
                        accept="image/*"
                        id="business-input"
                      />
                    </label>
                    {profileLogo &&
                      <span>
                        <a
                          style={{ cursor: "pointer" }}
                        >
                          <FaEye className="eye-color mt-1" data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Click to view image"
                            onClick={(e) => handleChangeProfileDownload()}
                          />
                        </a>{" "}
                        <span className="input_filname"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={businessLogoNAme}
                          style={{
                            display: "inline-block",
                            maxWidth: "300px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {" "}
                          {businessLogoNAme.length > 50 ? businessLogoNAme.slice(0, 50) + "..." : businessLogoNAme}
                        </span>
                        <span
                          onClick={() => handleDeleteClick()}
                        >
                          <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{ marginLeft: "10px" }} />
                        </span>
                        <br />
                      </span>
                    }
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col">

                    <p className="text_st mb-2">Comment<span className="text-danger">*</span></p>
                    <Form>
                      <Form.Group
                        className=" "
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Control
                          size="sm"
                          className="complaince_pendingLink_notes"
                          name="textarea"
                          as="textarea"
                          rows={2}
                          placeholder="Please type comment here."
                          onChange={handleChangeInputNotes}
                        />
                      </Form.Group>
                    </Form>

                  </div>
                </div>
              </div>}
            </div>
          </div>

        </Modal.Body>}


      <Modal.Footer className="d-flex  ps-3 pe-3 ">
        <div>
          <button
            className="btn btn_background px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
        {(data?.status === COMPLIANCE_PENDING) && <div>
          <button
            className="btn mx-2 py-2 px-3"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="secondary"
            onClick={handleShowReject}
            disabled={!pendingLinkNotes || roleCode === AUDITOR_ROLE}
          >
            Reject
          </button>
        </div>}

        {(data?.status === COMPLIANCE_PENDING) && <div>
          <button
            className="btn blue_btn me-3 px-4 py-2"
            onClick={approveKYC}
            disabled={approveKYCBtn || roleCode === AUDITOR_ROLE || isRiskPendingForIndividual}
          >
            Approve KYC
          </button>
        </div>}
      </Modal.Footer>

      <Modal show={show} onHide={handleCloseRejectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="alert_modal">
          Are you sure you want to reject?
        </Modal.Body>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectClose}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={handleCloseReject}
          >
            Yes
          </button>
        </div>
      </Modal>
    </Modal>
  );
};


const ModalFieldNoBorder = ({ label, value }) => {
  return (
    <div className="col me-2 compliance_bd_ab">
      <div className="mb-3">
        <p className="text_st">{label}</p>
        <span className="bolder_text ">
          {value === undefined || value === "" ? "-" : value}
        </span>
      </div>
    </div>
  );
};
const ModalField = ({ label, value }) => {
  return (
    <div className="col ">
      <div className="mb-3">
        <p className="text_st pb-1 ">{label}</p>
        <div class="kycFiledstyle">
          <span className="bolder_text ">
            {value === undefined || value === "" ? "-" : value}
          </span>
        </div>
      </div>
    </div>
  );
};


export const FillingFormModal = (props) => {
  let fillingFormdata = props.data;


  const [isUpload, setUpload] = useState(false);
  const [file, setUploadFile] = useState(null);
  const [url, setUploadedUrl] = useState(null);

  const [momDate, setMomDate] = useState(null);
  const [whoWasMet, setWhoWasMet] = useState("");
  const [whoVisited, setWhoVisited] = useState("");
  const [subject, setSubject] = useState("");
  const [financialStatus, setFinancialStatus] = useState("");
  const [promoterStatus, setPromoterStatus] = useState("");
  const [redFlag, setRedFlag] = useState("");
  const [newRequests, setNewRequests] = useState("");

  const handleClose = () => {
    props.onHide();
    setNewRequests("");
    setRedFlag("");
    setPromoterStatus("");
    setFinancialStatus("");
    setSubject("");
    setWhoVisited("");
    setWhoWasMet("");
    setMomDate();
    setUpload(false);
    setUploadFile(null);
    setUploadedUrl(null);
  };


  const handleChange = (event) => {
    if (event.target.files[0].size < 5242880) {
      setUpload(true);
      setUploadFile(event.target.files[0].name);
      setUploadedUrl(event.target.files[0]);
      setUpload(false);
    } else {
      toast.error("File size should be less than 5MB", {
        toastId: 7,
      });
    }
  };

  const handleChangeInput = (e) => {
    const { target } = e;
    const value = target.value;
    const name = target.name;

    if (name === "momdate") {
      let datnum = Date.parse(e.target.value);
      if (isNaN(datnum)) {
        setMomDate(null);
        datnum = "";
      } else {
        setMomDate(datnum);
      }
    }
    if (name === "whowasmet") {
      if (value === "" || value === undefined) {
        setWhoWasMet("");
      } else {
        setWhoWasMet(value);
      }
    }
    if (name === "whovisited") {
      if (value === "" || value === undefined) {
        setWhoVisited("");
      } else {
        setWhoVisited(value);
      }
    }
    if (name === "subject") {
      if (value === "" || value === undefined) {
        setSubject("");
      } else {
        setSubject(value);
      }
    }
    if (name === "financialstatus") {
      if (value === "" || value === undefined) {
        setFinancialStatus("");
      } else {
        setFinancialStatus(value);
      }
    }
    if (name === "promoterstatus") {
      if (value === "" || value === undefined) {
        setPromoterStatus("");
      } else {
        setPromoterStatus(value);
      }
    }
    if (name === "redflags") {
      if (value === "" || value === undefined) {
        setRedFlag("");
      } else {
        setRedFlag(value);
      }
    }
    if (name === "newrequests") {
      if (value === "" || value === undefined) {
        setNewRequests("");
      } else {
        setNewRequests(value);
      }
    }
  };
  const handleDownload = (event, file) => {
    const fileUrl = URL.createObjectURL(url);
    window.open(fileUrl, "_blank");
  };

  const [saveLoading, setSaveLoading] = useState(false)
  const submitted = () => {
    const fd1 = new FormData();
    fd1.append("business_id", fillingFormdata.business_id);
    fd1.append("admin_id", Cookies.get("admin_user_id"));
    fd1.append("meeting_date", momDate);
    fd1.append("name_of_person_met", whoWasMet);
    fd1.append("name_of_person_visited", Cookies.get("admin_user_name"));
    fd1.append("subject_of_meeting", subject);
    fd1.append("current_financial_status", financialStatus);
    fd1.append("current_status_of_promoter", promoterStatus);
    fd1.append("red_flag", redFlag);
    fd1.append("new_requests", newRequests);
    fd1.append("created_by", fillingFormdata.user_name);
    if (url != null) {
      const fileName = file;
      const lastDotIndex = fileName.lastIndexOf(".");
      const fileExtension = fileName.substring(lastDotIndex + 1);
      fd1.append("file", url, fileExtension);
    }

    if (
      momDate === undefined ||
      momDate === "" ||
      momDate === null ||
      whoWasMet === undefined ||
      whoWasMet === "" ||
      whoWasMet === null
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 3,
      });
    } else {
      setSaveLoading(true)

      axios
        .post(base_url + "mom-report-information/save_mom_report_info", fd1, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            props.onHide();
            toast.success("Sucessfully Saved", {
              toastId: 20,
            });
            setTimeout(() => {
              window.location.reload();
            }, 800);
            setSaveLoading(false)

          }
        });
    }
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">MOM Report Info</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={`${saveLoading ? 'px-4' : 'px-4 py-2'}`}
        style={{ height: "28rem", overflow: "auto" }}
      >
        <div className={saveLoading ? "onClickApplyLoaderStyl" : "d-none"}>
          <ThreeDots
            height="60"
            width="60"
            radius="9"
            color="#3d79f3"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={saveLoading}
          />
        </div>
        <div>
          <div className="row">
            <div className="col-lg-3 pe-3">
              <div className="form-group datepickermom_report">
                <label htmlFor="momdate " className="mb-0">
                  <p>
                    Date
                    <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <input
                  name="momdate"
                  id="momdate"
                  type="date"
                  className="form-control rounded "
                  onChange={handleChangeInput}
                />
              </div>
            </div>

            <div className="col pe-3 cust_placeholder_styl">
              <label htmlFor="companyname">
                <p>Name Of the Company</p>
              </label>
              <br />
              <input
                type="text"
                className="APNL_option_flds rounded  shadow-ben"
                id="companyname"
                name="companyname"
                required
                role="presentation"
                autoComplete="off"
                disabled
                value={fillingFormdata.business_name}
              // onChange={handleChangeInput}
              />
            </div>

            <div className="col pe-2 cust_placeholder_styl">
              <label htmlFor="whowasmet">
                <p>
                  Who was Met <span style={{ color: "red" }}>*</span>
                </p>
              </label>
              <br />
              <input
                type="text"
                className="APNL_option_flds rounded  shadow-ben"
                id="whowasmet"
                name="whowasmet"
                placeholder="Enter the person name you met"
                required
                role="presentation"
                autoComplete="off"
                onChange={handleChangeInput}
              />
            </div>
          </div>

          <div className="row cust_placeholder_styl">
            <div className="col-lg-5 pe-2 mt-3">
              <label htmlFor="whovisited">
                <p>Who Visited</p>
              </label>
              <br />
              <input
                type="text"
                className="APNL_option_flds rounded  shadow-ben"
                id="whovisited"
                name="whovisited"
                value={
                  Cookies.get("admin_user_name")[0].toUpperCase() +
                  Cookies.get("admin_user_name").slice(1)
                }
                disabled
                role="presentation"
                autoComplete="off"
                onChange={handleChangeInput}
              />
            </div>
          </div>
          <hr />

          <div className="d-flex flex-column gap-4">
            <div>
              <p className="mb-1">Subject of the Meeting </p>
              <Form>
                <Form.Group
                  className=" "
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    size="sm"
                    className="ANLtextarea"
                    name="subject"
                    as="textarea"
                    rows={2}
                    placeholder=""
                    onChange={handleChangeInput}
                  />
                </Form.Group>
              </Form>
            </div>
            <div>
              <p className="mb-1">Current Financial Status of the Company</p>
              <Form>
                <Form.Group
                  className=" "
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    size="sm"
                    className="ANLtextarea"
                    name="financialstatus"
                    as="textarea"
                    rows={2}
                    placeholder=""
                    onChange={handleChangeInput}
                  />
                </Form.Group>
              </Form>
            </div>
            <div>
              <p className="mb-1">
                Current Status of the Promoter of the Company
              </p>
              <Form>
                <Form.Group
                  className=" "
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    size="sm"
                    className="ANLtextarea"
                    name="promoterstatus"
                    as="textarea"
                    rows={2}
                    placeholder=""
                    onChange={handleChangeInput}
                  />
                </Form.Group>
              </Form>
            </div>
            <div>
              <p className="mb-1">Any Red Flags</p>
              <Form>
                <Form.Group
                  className=" "
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    size="sm"
                    className="ANLtextarea"
                    name="redflags"
                    as="textarea"
                    rows={2}
                    placeholder=""
                    onChange={handleChangeInput}
                  />
                </Form.Group>
              </Form>
            </div>
            <div>
              <p className="mb-1">Any New Requests </p>
              <Form>
                <Form.Group
                  className=" "
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    size="sm"
                    className="ANLtextarea mb-4"
                    name="newrequests"
                    as="textarea"
                    rows={2}
                    placeholder=""
                    onChange={handleChangeInput}
                  />
                </Form.Group>
              </Form>
            </div>
          </div>
          <div className="mb-4 d-flex gap-5">
            <label className="Cpointer " onChange={(e) => handleChange(e)}>
              <div className="upload_report_btn ">
                <input type="file" />
                <span className="">
                  <img src="./images/upload.svg" alt="" />
                  Upload Documents/Images
                </span>
              </div>
            </label>
          </div>
          <div className="mt-3">
            <div className="upload_file_name ">
              <div
                className="container d-flex gap-5"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={file}
              >
                <div>
                  {file != null
                    ? file.length > 25
                      ? file.slice(0, 25) + ".."
                      : file
                    : ""}
                </div>
                <div>
                  {file !== null && (
                    <a
                      style={{
                        display: "table-cell",
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className="fa-solid fa-eye text-primary fa-eye-font mt-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Click to view image"
                        onClick={(e) => handleDownload(e, file)}
                      />
                    </a>
                  )}
                </div>
              </div>
            </div>

            {isUpload && (
              <div className="loader">
                <ThreeDots
                  height="30"
                  width="30"
                  radius="9"
                  color="#3D79F3"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3 ">
        <div>
          <button
            className="btn btn_background px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
        <div>
          <button
            className="btn blue_btn me-3 px-4 py-2"
            onClick={submitted}
            disabled={
              momDate === undefined ||
                momDate === "" ||
                momDate === null ||
                whoWasMet === undefined ||
                whoWasMet === "" ||
                whoWasMet === null
                ? true
                : false
            }
          >
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};


export const Filters = ({ label, className, disabled, htmlFor, name, data, onChange, id, defaultvalue, selectedValue }) => {
  const options =
    data.map(item => ({ value: name, label: item }));
  const value = selectedValue ? {
    value: name,
    label: selectedValue
  } : null;

  return (
    <div className={className}>
      <label htmlFor={htmlFor} className="form-label">
        <p>{label}</p>
      </label>
      <Select
        isDisabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        options={options}
        value={value}
        classNamePrefix="custom-select"
      />
    </div>
  );
};


export const OnboardingApprovalModal = (props) => {
  let data = props.data;
  const handleClose = () => {
    props.onHide();
  };
  const [pendingLinkNotes, setPendingLinkNotes] = useState("");
  const handleChangeInputNotes = (e) => {
    let value = e.target.value;
    if (value === undefined || value === "" || value === null) {
      setPendingLinkNotes("");
    } else setPendingLinkNotes(e.target.value);
  };

  let processing_fee_options = [
    { type: "Yes", id: 1 },
    { type: "No", id: 2 },
  ];

  const [radio_Value, setRadio_Value] = useState("");


  const [businessuserName, setBusinessuserName] = useState("");
  const handleChangeInputusername = (e) => {
    setBusinessuserName(e.target.value);
  };

  const approveBusiness = () => {
    if (businessuserName === "") {
      toast.error("Please enter business username", {
        toastId: 100,
      });
    } else {
      let myObject = {
        business_id: data.business_id,
        admin_user_id: Cookies.get("admin_user_id"),
        admin_notes: pendingLinkNotes,
        validated_by: Cookies.get("admin_user_name"),
        user_name: businessuserName,
      };
      axios
        .post(base_url + "business-master/approve_business", myObject)
        .then((res) => {
          if (res.data.status == 200) {
            toast.success("Business Approved Successfully", {
              toastId: 4,
            });
            props.onHide();
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        });
    }
  };
  const [show, setShow] = useState(false);

  const handleShowReject = () => setShow(true);
  const handleCloseRejectClose = () => {
    setShow(false);
  };

  const handleCloseReject = () => {
    //hit the api from rejection api here

    let myObject = {
      business_id: data.business_id,
      admin_notes: pendingLinkNotes,
      transaction_alignment: radio_Value === "Yes" ? 1 : 0,
      validated_by: Cookies.get("admin_user_name"),
      admin_user_id: Cookies.get("admin_user_id"),
    };
    axios
      .post(base_url + "business-master/reject_business", myObject)
      .then((res) => {
        if (res.data.status == 200) {
          props.onHide();
          toast.success("Rejected Successfully", {
            toastId: 4,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Business Details</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="px-4 py-2"
        style={{
          height: data.onboard_status === COMPLIANCE_APPROVED ? "20rem" : "28rem",
          overflow: "auto",
        }}
      >

        <div className="container p-0 pb-3">
          <div className="row">
            <div className="col me-3 compliance_bd_ab">
              <div className="mb-3">
                <p className="text_st ">Business Name</p>
                <span className="bolder_text ">
                  {!data.business_name ? "-" : data.business_name}
                </span>
              </div>
            </div>

            <div className="col me-2 compliance_bd_ab">
              <div className="mb-3">
                <p className="text_st ">Contact Person</p>
                <span className="bolder_text ">
                  {!data.contact_person
                    ? "-" : data.contact_person}
                </span>
              </div>
            </div>



            <div className="col compliance_bd_ab">
              <div className="mb-3">
                <p className="text_st ">Phone</p>
                <span className="bolder_text ">
                  {!data.phone ? "-" : data.phone}
                </span>
              </div>
            </div>

            <div class="row">

              <div className=" col me-3 compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Country of Business</p>
                  <span className="bolder_text ">
                    {data.country === undefined || data.country === '' || data.country === "undefined" ? "-" : data.country}
                  </span>
                </div>
              </div>

              <div className="col compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Business Type</p>
                  <span className="bolder_text ">
                    {!data.business_type ? "-" : data.business_type}
                  </span>
                </div>
              </div>
              <div className="col compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Year of Establishment</p>
                  <span className="bolder_text ">
                    {!data.year_of_establishment
                      ? "-" : data.year_of_establishment}
                  </span>
                </div>
              </div>
              {/* <div className="col"></div> */}
            </div>
            <div class="row">
              <div className="mb-3 col me-3 compliance_bd_ab">
                <p className="text_st ">turnover</p>
                <span className="bolder_text ">
                  {data.turnover == undefined
                    ? "-"

                    : data.turnover
                  }
                </span>
              </div>
              <div className="col compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Where did you hear about us?</p>
                  <span className="bolder_text ">
                    {!data.hear_about_us ? "-" : data.hear_about_us}
                  </span>
                </div>
              </div>
              <div className="col compliance_bd_ab">
                <div className="mb-3">
                  <p className="text_st ">Email</p>
                  <span className="bolder_text ">
                    {!data.email
                      ? "-" : data.email}
                  </span>
                </div>
              </div>

            </div>

            <div className="row">

              <div className="mb-3 col me-3 compliance_bd_ab">
                <p className="text_st ">Status</p>
                <span className="bolder_text ">
                  {data.onboard_status == undefined
                    ? "-"

                    : data.onboard_status === COMPLIANCE_PENDING
                      ? "Pending"
                      : data.onboard_status === COMPLIANCE_APPROVED
                        ? "Approved"

                        : "Rejected"
                  }
                </span>
              </div>


            </div>
            {data.onboard_status === COMPLIANCE_APPROVED ? <div></div> :
              <hr />}

            {data.onboard_status === COMPLIANCE_APPROVED ? <div></div> :
              <div className="row ">
                <div className="col">
                  <div className="col-lg-4">
                    <form className="form-group col mb-2 mt-0 custm_input_styl aksjdhf">
                      <label htmlFor="ulitmateholders">
                        <p>
                          {" "}
                          Enter Business Username
                          <span style={{ color: "red" }}>*</span>{" "}
                        </p>
                      </label>
                      <input
                        type="text"
                        name="ulitmateholders"
                        id="disabledTextInput"
                        className="form-control bg-white"
                        onChange={handleChangeInputusername}
                        disabled={data.onboard_status === COMPLIANCE_APPROVED}
                      />
                    </form>
                  </div>

                  <p className="text_st mb-2">Comment<span className="text-danger">*</span></p>
                  <Form>
                    <Form.Group
                      className=" "
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Control
                        size="sm"
                        className="complaince_pendingLink_notes"
                        name="textarea"
                        as="textarea"
                        rows={2}
                        placeholder="Please type comment here."
                        onChange={handleChangeInputNotes}
                      // disabled={data.onboard_status === COMPLIANCE_APPROVED}
                      />
                    </Form.Group>
                  </Form>


                </div>
              </div>
            }
          </div>
        </div>
      </Modal.Body>

      {data.onboard_status === COMPLIANCE_APPROVED ? <div></div> :
        <Modal.Footer className="d-flex  ps-3 pe-3 ">
          <div>
            <button
              className="btn btn_background px-3 py-2"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
          <div>
            <button
              className="btn mx-2 py-2 px-3"
              style={{ backgroundColor: "#ED5151", color: "white" }}
              variant="secondary"
              onClick={handleShowReject}
              disabled={props.role_code === AUDITOR_ROLE}
            >
              Reject
            </button>
          </div>

          <div>
            <button
              className="btn blue_btn me-3 px-4 py-2"
              onClick={approveBusiness}
              disabled={props.role_code === AUDITOR_ROLE}
            >
              Approve Business
            </button>
          </div>
        </Modal.Footer>
      }


      <Modal show={show} onHide={handleCloseRejectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="alert_modal">
          Are you sure you want to reject?
        </Modal.Body>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectClose}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={handleCloseReject}
          >
            Yes
          </button>
        </div>
      </Modal>
    </Modal>
  );
};


export const NoDocs = () => {
  return (
    <div className="py-2 border fw-bolder my-3 rounded w-25 text-center">No documents uploaded</div>
  );
};
